import "./piva-ordinaria.9b85864f.js";
import "./piva-ordinaria.4e8012e8.js";


function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6be7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6be7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("01FIu", function(module, exports) {

$parcel$export(module.exports, "handleShareClick", () => $0050742cc8f2b4a1$export$1471aabd64a580f1);

var $j591w = parcelRequire("j591w");
/**
 * Share helper:
 * Two-tap UX (iOS-safe):
 * - Tap #1: generates the short URL (Firestore) and updates button label to "Copia link".
 * - Tap #2: copies the already-generated short URL to clipboard (no `await` before copy).
 */ const $0050742cc8f2b4a1$var$ICON_SHARE = 'ph ph-share-network';
const $0050742cc8f2b4a1$var$ICON_COPY = 'ph ph-copy';
const $0050742cc8f2b4a1$var$ICON_CHECK = 'ph ph-check';
function $0050742cc8f2b4a1$var$setButtonVisual(shareButton, { label: label, iconClass: iconClass } = {}) {
    const textNode = shareButton.querySelector('.button-text');
    const iconNode = shareButton.querySelector('i');
    if (iconClass) {
        if (iconNode) iconNode.className = iconClass;
        else {
            const newIcon = document.createElement('i');
            newIcon.className = iconClass;
            shareButton.prepend(newIcon);
            shareButton.insertAdjacentText('afterbegin', ' ');
        }
    }
    if (textNode) {
        if (typeof label === 'string') textNode.textContent = label;
        return;
    }
    if (iconNode) {
        if (typeof label === 'string') shareButton.innerHTML = `${iconNode.outerHTML} ${label}`;
        return;
    }
    if (typeof label === 'string') shareButton.textContent = label;
}
function $0050742cc8f2b4a1$var$fallbackCopyTextToClipboard(text) {
    try {
        const textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.setAttribute('readonly', '');
        textarea.style.position = 'fixed';
        textarea.style.top = '-1000px';
        textarea.style.left = '-1000px';
        document.body.appendChild(textarea);
        textarea.focus();
        textarea.select();
        textarea.setSelectionRange(0, textarea.value.length);
        const ok = document.execCommand('copy');
        document.body.removeChild(textarea);
        return ok;
    } catch (error) {
        return false;
    }
}
async function $0050742cc8f2b4a1$var$copyToClipboard(text) {
    try {
        if (navigator.clipboard && window.isSecureContext) {
            await navigator.clipboard.writeText(text);
            return true;
        }
    } catch (error) {
    // fall through
    }
    const ok = $0050742cc8f2b4a1$var$fallbackCopyTextToClipboard(text);
    if (ok) return true;
    // Last resort: manual copy (does NOT auto-copy)
    window.prompt('Copia il link:', text);
    return false;
}
async function $0050742cc8f2b4a1$export$1471aabd64a580f1(shareButton, options = {}) {
    if (!shareButton) return;
    const { campaign: campaign = 'sharing_link', generatingText: generatingText = 'Generazione...', readyText: readyText = 'Copia link', copiedText: copiedText = 'Link copiato', resetAfterMs: resetAfterMs = 1500 } = options;
    if (!shareButton.dataset.shareOriginalContent) shareButton.dataset.shareOriginalContent = shareButton.innerHTML;
    const existingShortUrl = shareButton.dataset.shareShortUrl;
    const isReadyToCopy = shareButton.dataset.shareStage === 'ready' && !!existingShortUrl;
    // Tap #2: copy (iOS-safe because we don't `await` anything before choosing the text to copy)
    if (isReadyToCopy) {
        shareButton.disabled = true;
        try {
            await $0050742cc8f2b4a1$var$copyToClipboard(existingShortUrl);
            $0050742cc8f2b4a1$var$setButtonVisual(shareButton, {
                label: copiedText,
                iconClass: $0050742cc8f2b4a1$var$ICON_CHECK
            });
        } finally{
            setTimeout(()=>{
                shareButton.disabled = false;
                $0050742cc8f2b4a1$var$setButtonVisual(shareButton, {
                    label: readyText,
                    iconClass: $0050742cc8f2b4a1$var$ICON_COPY
                });
            }, resetAfterMs);
        }
        return;
    }
    // Tap #1: generate short URL (Firestore)
    shareButton.disabled = true;
    $0050742cc8f2b4a1$var$setButtonVisual(shareButton, {
        label: generatingText,
        iconClass: $0050742cc8f2b4a1$var$ICON_SHARE
    });
    try {
        const shortUrl = await (0, $j591w.createShortUrl)(window.location.href, campaign);
        shareButton.dataset.shareShortUrl = shortUrl;
        shareButton.dataset.shareStage = 'ready';
        $0050742cc8f2b4a1$var$setButtonVisual(shareButton, {
            label: readyText,
            iconClass: $0050742cc8f2b4a1$var$ICON_COPY
        });
    } catch (error) {
        console.error('Short URL creation failed', error);
        shareButton.dataset.shareStage = 'error';
        $0050742cc8f2b4a1$var$setButtonVisual(shareButton, {
            label: 'Errore, riprova',
            iconClass: $0050742cc8f2b4a1$var$ICON_SHARE
        });
        setTimeout(()=>{
            shareButton.innerHTML = shareButton.dataset.shareOriginalContent;
            delete shareButton.dataset.shareStage;
            delete shareButton.dataset.shareShortUrl;
        }, 2000);
    }
    shareButton.disabled = false;
}

});
parcelRegister("j591w", function(module, exports) {

$parcel$export(module.exports, "createShortUrl", () => $de457bdbc5c961c5$export$181919154f900a5b);
// Firestore serve solo quando l'utente condivide: si carica a quel momento,
// cosi' le pagine che importano questo modulo non pagano i 350 KB dell'SDK.


async function $de457bdbc5c961c5$var$caricaFirestore() {
    const [firestore, { firebaseInit: firebaseInit }] = await Promise.all([
        (parcelRequire("cet9q")),
        (parcelRequire("gQnFK"))
    ]);
    return {
        ...firestore,
        firebaseInit: firebaseInit
    };
}
const $de457bdbc5c961c5$var$CHARSET = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz23456789';
// Referral UTM policy (requested):
// - utm_source=referral
// - utm_medium=referral
// - utm_campaign=sharing_link
const $de457bdbc5c961c5$var$DEFAULT_SOURCE = 'referral';
const $de457bdbc5c961c5$var$DEFAULT_MEDIUM = 'referral';
const $de457bdbc5c961c5$var$DEFAULT_CAMPAIGN = 'sharing_link';
function $de457bdbc5c961c5$var$generateShortCode(length = 6) {
    let code = '';
    for(let i = 0; i < length; i += 1)code += $de457bdbc5c961c5$var$CHARSET.charAt(Math.floor(Math.random() * $de457bdbc5c961c5$var$CHARSET.length));
    return code;
}
function $de457bdbc5c961c5$export$d0bba44cbdf15a1a(originalUrl, campaign = $de457bdbc5c961c5$var$DEFAULT_CAMPAIGN) {
    try {
        const url = new URL(originalUrl, window.location.origin);
        // Force consistent referral UTMs (overwrite any existing UTMs)
        url.searchParams.set('utm_source', $de457bdbc5c961c5$var$DEFAULT_SOURCE);
        url.searchParams.set('utm_medium', $de457bdbc5c961c5$var$DEFAULT_MEDIUM);
        url.searchParams.set('utm_campaign', campaign || $de457bdbc5c961c5$var$DEFAULT_CAMPAIGN);
        return url.toString();
    } catch (error) {
        console.error('appendShareTrackingParams failed', error);
        return originalUrl;
    }
}
async function $de457bdbc5c961c5$var$getUniqueShortCode(shortUrlsRef, { doc: doc, getDoc: getDoc }) {
    const maxAttempts = 5;
    for(let attempt = 0; attempt < maxAttempts; attempt += 1){
        const shortCode = $de457bdbc5c961c5$var$generateShortCode(6 + Math.floor(Math.random() * 3));
        const docRef = doc(shortUrlsRef, shortCode);
        const existing = await getDoc(docRef);
        if (!existing.exists()) return {
            shortCode: shortCode,
            docRef: docRef
        };
    }
    throw new Error('Unable to generate unique short code');
}
async function $de457bdbc5c961c5$export$181919154f900a5b(originalUrl, campaign = $de457bdbc5c961c5$var$DEFAULT_CAMPAIGN) {
    const trackedUrl = $de457bdbc5c961c5$export$d0bba44cbdf15a1a(originalUrl, campaign);
    const firestore = await $de457bdbc5c961c5$var$caricaFirestore();
    const { getFirestore: getFirestore, collection: collection, setDoc: setDoc, serverTimestamp: serverTimestamp, firebaseInit: firebaseInit } = firestore;
    const { app: app } = firebaseInit();
    const db = getFirestore(app);
    const shortUrlsRef = collection(db, 'shortUrls');
    const { shortCode: shortCode, docRef: docRef } = await $de457bdbc5c961c5$var$getUniqueShortCode(shortUrlsRef, firestore);
    const payload = {
        originalUrl: trackedUrl,
        shortCode: shortCode,
        baseUrl: window.location.origin,
        createdAt: serverTimestamp(),
        utm_source: $de457bdbc5c961c5$var$DEFAULT_SOURCE,
        utm_medium: $de457bdbc5c961c5$var$DEFAULT_MEDIUM,
        utm_campaign: campaign || $de457bdbc5c961c5$var$DEFAULT_CAMPAIGN
    };
    await setDoc(docRef, payload);
    const base = window.location.origin || 'https://www.stipendee.it';
    return `${base}/s/${shortCode}`;
}

});
parcelRegister("cet9q", function(module, exports) {
module.exports = Promise.all([
    import("gyHl0"),
    import("eF1tK")
]).then(()=>parcelRequire('ilpIi'));

});

parcelRegister("gQnFK", function(module, exports) {
module.exports = Promise.all([
    import("gyHl0"),
    import("jYu4x")
]).then(()=>parcelRequire('4QApW'));

});



parcelRegister("9dryX", function(module, exports) {

$parcel$export(module.exports, "getComuneSelezionato", () => $6b5ab55d30331bca$export$3e7c72272eb1c22e);
$parcel$export(module.exports, "initComuneAutocomplete", () => $6b5ab55d30331bca$export$e4a5c0d41dd66a05);
// Autocomplete del comune per l'addizionale comunale IRPEF.
// I dati (generati da scripts/build-addizionali-comunali.js, fonte MEF) sono
// divisi per regione e caricati on-demand alla selezione della regione, cosi'
// il bundle principale non cresce.
//
// Il selettore e' un combobox custom (input + dropdown gestita da noi) invece
// del <datalist> nativo: quest'ultimo ha comportamenti incoerenti tra browser
// e soprattutto su mobile (a volte non compare, filtra diversamente, non si
// puo' stilizzare). Il combobox custom funziona in modo identico ovunque e
// supporta tastiera, mouse e touch.
// Le chiavi corrispondono alle option del select #regione. Import literal per
// permettere a Parcel il code splitting.





















const $6b5ab55d30331bca$var$REGIONE_LOADERS = {
    'Abruzzo': ()=>(parcelRequire("cVJ7L")),
    'Basilicata': ()=>(parcelRequire("3Vig3")),
    'Bolzano': ()=>(parcelRequire("be8H4")),
    'Calabria': ()=>(parcelRequire("iFFpZ")),
    'Campania': ()=>(parcelRequire("8vE1O")),
    'Emilia-Romagna': ()=>(parcelRequire("8zAUd")),
    'Friuli Venezia-Giulia': ()=>(parcelRequire("gyxoc")),
    'Lazio': ()=>(parcelRequire("kRhAd")),
    'Liguria': ()=>(parcelRequire("7u9n8")),
    'Lombardia': ()=>(parcelRequire("7CiPK")),
    'Marche': ()=>(parcelRequire("8BLqv")),
    'Molise': ()=>(parcelRequire("3ccGn")),
    'Piemonte': ()=>(parcelRequire("dYw3h")),
    'Puglia': ()=>(parcelRequire("jPuI6")),
    'Sardegna': ()=>(parcelRequire("e7TnA")),
    'Sicilia': ()=>(parcelRequire("iTVKm")),
    'Toscana': ()=>(parcelRequire("1y8kQ")),
    'Trento': ()=>(parcelRequire("eVGdJ")),
    'Umbria': ()=>(parcelRequire("45a6i")),
    "Valle d'Aosta": ()=>(parcelRequire("hJIAG")),
    'Veneto': ()=>(parcelRequire("fmao9"))
};
// Massimo numero di risultati mostrati nella dropdown: per regioni con
// migliaia di comuni evita liste ingestibili e DOM inutilmente grande.
const $6b5ab55d30331bca$var$MAX_RISULTATI = 50;
const $6b5ab55d30331bca$var$etichettaComune = ([nome, pr])=>`${nome} (${pr})`;
// Normalizza per il confronto: rimuove accenti e maiuscole cosi' "forli"
// trova "Forli'" e la ricerca e' insensibile ad accenti/maiuscole.
const $6b5ab55d30331bca$var$normalizza = (s)=>s.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
// Aliquota mostrata nel campo percentuale: per i comuni a scaglioni si usa
// l'aliquota massima come riferimento visivo; il calcolo vero usa gli scaglioni.
const $6b5ab55d30331bca$var$aliquotaIndicativa = (record)=>{
    const valore = record[2];
    if (Array.isArray(valore)) return Math.max(...valore.map(([, a])=>a));
    return valore;
};
let $6b5ab55d30331bca$var$comuniCorrenti = new Map(); // etichetta -> record [nome, pr, aliquota|scaglioni, esenzione]
let $6b5ab55d30331bca$var$recordsCorrenti = []; // stessi record in array, per il filtro della dropdown
let $6b5ab55d30331bca$var$selezione = null;
let $6b5ab55d30331bca$var$impostazioneProgrammatica = false;
function $6b5ab55d30331bca$export$3e7c72272eb1c22e() {
    if (!$6b5ab55d30331bca$var$selezione) return null;
    const [nome, pr, valore, esenzione] = $6b5ab55d30331bca$var$selezione;
    return {
        nome: `${nome} (${pr})`,
        esenzione: esenzione,
        scaglioni: Array.isArray(valore) ? valore : null,
        aliquota: Array.isArray(valore) ? null : valore
    };
}
function $6b5ab55d30331bca$export$e4a5c0d41dd66a05() {
    const regioneSelect = document.getElementById('regione');
    const comuneInput = document.getElementById('comune');
    const dropdown = document.getElementById('comuni-list');
    const aliquotaInput = document.getElementById('addizionale-comunale');
    const nota = document.getElementById('comune-note');
    if (!regioneSelect || !comuneInput || !dropdown || !aliquotaInput) return;
    const percentuale = (n)=>`${n.toFixed(2).replace('.', ',')}%`;
    const euro = (n)=>`${n.toLocaleString('it-IT')} \u{20AC}`;
    // -- Stato della dropdown --------------------------------------------------
    let risultati = []; // record attualmente mostrati
    let attivo = -1; // indice dell'opzione evidenziata (tastiera)
    let aperta = false;
    let chiudiTimer = null;
    const aggiornaNota = ()=>{
        if (!nota) return;
        if (!$6b5ab55d30331bca$var$selezione) {
            nota.textContent = "Seleziona il tuo comune: l'addizionale comunale ufficiale viene applicata in automatico.";
            return;
        }
        const [, , valore, esenzione] = $6b5ab55d30331bca$var$selezione;
        const testoAliquota = Array.isArray(valore) ? `Addizionale comunale a scaglioni, fino allo ${percentuale($6b5ab55d30331bca$var$aliquotaIndicativa($6b5ab55d30331bca$var$selezione))}` : `Addizionale comunale: ${percentuale(valore)}`;
        const testoEsenzione = esenzione > 0 ? `, esente fino a ${euro(esenzione)} di imponibile` : '';
        nota.textContent = `${testoAliquota}${testoEsenzione}. Fonte MEF.`;
    };
    const azzeraSelezione = ()=>{
        $6b5ab55d30331bca$var$selezione = null;
        comuneInput.classList.remove('comune-riconosciuto');
        // il campo aliquota non e' piu' visibile: senza comune torna al default
        $6b5ab55d30331bca$var$impostazioneProgrammatica = true;
        aliquotaInput.value = '0.80';
        aliquotaInput.dispatchEvent(new Event('change'));
        $6b5ab55d30331bca$var$impostazioneProgrammatica = false;
        aggiornaNota();
    };
    const applicaSelezione = (record)=>{
        $6b5ab55d30331bca$var$selezione = record;
        $6b5ab55d30331bca$var$impostazioneProgrammatica = true;
        aliquotaInput.value = $6b5ab55d30331bca$var$aliquotaIndicativa(record).toFixed(2);
        aliquotaInput.dispatchEvent(new Event('change'));
        $6b5ab55d30331bca$var$impostazioneProgrammatica = false;
        comuneInput.classList.add('comune-riconosciuto');
        aggiornaNota();
    };
    // -- Dropdown custom -------------------------------------------------------
    const chiudi = ()=>{
        if (!aperta) return;
        aperta = false;
        dropdown.classList.add('hidden');
        dropdown.replaceChildren();
        comuneInput.setAttribute('aria-expanded', 'false');
        comuneInput.removeAttribute('aria-activedescendant');
        attivo = -1;
        risultati = [];
    };
    const filtra = (query)=>{
        const nq = $6b5ab55d30331bca$var$normalizza(query);
        if (!nq) return $6b5ab55d30331bca$var$recordsCorrenti.slice(0, $6b5ab55d30331bca$var$MAX_RISULTATI);
        const iniziano = [];
        const contengono = [];
        for (const record of $6b5ab55d30331bca$var$recordsCorrenti){
            const nome = $6b5ab55d30331bca$var$normalizza(record[0]);
            const idx = nome.indexOf(nq);
            if (idx === 0) iniziano.push(record);
            else if (idx > 0) contengono.push(record);
        }
        return iniziano.concat(contengono).slice(0, $6b5ab55d30331bca$var$MAX_RISULTATI);
    };
    const evidenzia = (indice)=>{
        const opzioni = dropdown.children;
        if (attivo >= 0 && opzioni[attivo]) opzioni[attivo].classList.remove('active');
        attivo = indice;
        const opzione = opzioni[attivo];
        if (opzione) {
            opzione.classList.add('active');
            comuneInput.setAttribute('aria-activedescendant', opzione.id);
            opzione.scrollIntoView({
                block: 'nearest'
            });
        } else comuneInput.removeAttribute('aria-activedescendant');
    };
    const scegli = (record)=>{
        comuneInput.value = $6b5ab55d30331bca$var$etichettaComune(record);
        applicaSelezione(record);
        chiudi();
    };
    const mostra = ()=>{
        if (comuneInput.disabled) return;
        risultati = filtra(comuneInput.value);
        dropdown.replaceChildren();
        attivo = -1;
        if (!risultati.length) {
            const vuoto = document.createElement('li');
            vuoto.className = 'comune-empty';
            vuoto.textContent = 'Nessun comune trovato';
            dropdown.appendChild(vuoto);
        } else {
            const frammento = document.createDocumentFragment();
            risultati.forEach((record, i)=>{
                const opzione = document.createElement('li');
                opzione.className = 'comune-option';
                opzione.id = `comune-opt-${i}`;
                opzione.setAttribute('role', 'option');
                opzione.dataset.indice = String(i);
                const spanNome = document.createElement('span');
                spanNome.className = 'comune-nome';
                spanNome.textContent = record[0];
                const spanPr = document.createElement('span');
                spanPr.className = 'comune-pr';
                spanPr.textContent = `(${record[1]})`;
                opzione.append(spanNome, spanPr);
                frammento.appendChild(opzione);
            });
            dropdown.appendChild(frammento);
        }
        dropdown.classList.remove('hidden');
        comuneInput.setAttribute('aria-expanded', 'true');
        aperta = true;
    };
    const caricaRegione = async (regione)=>{
        $6b5ab55d30331bca$var$comuniCorrenti = new Map();
        $6b5ab55d30331bca$var$recordsCorrenti = [];
        chiudi();
        const loader = $6b5ab55d30331bca$var$REGIONE_LOADERS[regione];
        if (!loader) {
            comuneInput.disabled = true;
            comuneInput.placeholder = 'Seleziona prima la regione';
            return;
        }
        try {
            const modulo = await loader();
            const dati = modulo?.default ?? modulo;
            $6b5ab55d30331bca$var$recordsCorrenti = dati.comuni;
            for (const record of dati.comuni)$6b5ab55d30331bca$var$comuniCorrenti.set($6b5ab55d30331bca$var$etichettaComune(record), record);
            comuneInput.disabled = false;
            comuneInput.placeholder = 'Cerca il tuo comune...';
            // ripristino da URL condiviso: se il campo ha gia' un valore, riabbina
            if (comuneInput.value) riconosciComune();
        } catch (err) {
            // dati non disponibili: il campo manuale resta pienamente funzionante
            console.error('addizionali comunali non caricate', err);
            comuneInput.disabled = true;
        }
    };
    // Riconosce un comune quando il testo digitato corrisponde esattamente a
    // un'etichetta (es. ripristino da URL o testo incollato); altrimenti azzera.
    const riconosciComune = ()=>{
        const record = $6b5ab55d30331bca$var$comuniCorrenti.get(comuneInput.value.trim());
        if (record) applicaSelezione(record);
        else azzeraSelezione();
    };
    // -- Eventi ----------------------------------------------------------------
    regioneSelect.addEventListener('change', ()=>{
        azzeraSelezione();
        comuneInput.value = '';
        caricaRegione(regioneSelect.value);
    });
    comuneInput.addEventListener('input', ()=>{
        riconosciComune();
        mostra();
    });
    comuneInput.addEventListener('change', riconosciComune);
    comuneInput.addEventListener('focus', ()=>{
        if (chiudiTimer) {
            clearTimeout(chiudiTimer);
            chiudiTimer = null;
        }
        mostra();
    });
    // Chiusura al blur con piccolo ritardo, cosi' il tap/click su un'opzione
    // (che avviene dopo il blur su alcuni dispositivi) fa in tempo a registrarsi.
    comuneInput.addEventListener('blur', ()=>{
        chiudiTimer = setTimeout(chiudi, 150);
    });
    comuneInput.addEventListener('keydown', (e)=>{
        if (!aperta && (e.key === 'ArrowDown' || e.key === 'ArrowUp')) {
            mostra();
            e.preventDefault();
            return;
        }
        if (!aperta) return;
        switch(e.key){
            case 'ArrowDown':
                e.preventDefault();
                if (risultati.length) evidenzia((attivo + 1) % risultati.length);
                break;
            case 'ArrowUp':
                e.preventDefault();
                if (risultati.length) evidenzia((attivo - 1 + risultati.length) % risultati.length);
                break;
            case 'Enter':
                if (attivo >= 0 && risultati[attivo]) {
                    e.preventDefault();
                    scegli(risultati[attivo]);
                }
                break;
            case 'Escape':
                chiudi();
                break;
            default:
                break;
        }
    });
    // mousedown sul contenitore: preventDefault mantiene il focus sull'input
    // (evita che il blur chiuda la lista prima del click). La selezione avviene
    // sul click, che scatta anche dopo un tap su touch ma non dopo uno scroll.
    dropdown.addEventListener('mousedown', (e)=>e.preventDefault());
    dropdown.addEventListener('click', (e)=>{
        const opzione = e.target.closest('.comune-option');
        if (!opzione) return;
        const record = risultati[Number(opzione.dataset.indice)];
        if (record) scegli(record);
    });
    // modifica manuale dell'aliquota = override: il calcolo torna alla
    // percentuale flat inserita dall'utente
    aliquotaInput.addEventListener('input', ()=>{
        if (!$6b5ab55d30331bca$var$impostazioneProgrammatica) azzeraSelezione();
    });
    // regione gia' valorizzata al load (es. ritorno dalla pagina risultati)
    if (regioneSelect.value) caricaRegione(regioneSelect.value);
    aggiornaNota();
}

});
parcelRegister("cVJ7L", function(module, exports) {
module.exports = import("12og1").then(()=>parcelRequire('gyh4v'));

});

parcelRegister("3Vig3", function(module, exports) {
module.exports = import("l4RBo").then(()=>parcelRequire('bm7vg'));

});

parcelRegister("be8H4", function(module, exports) {
module.exports = import("3qwqS").then(()=>parcelRequire('bmLtN'));

});

parcelRegister("iFFpZ", function(module, exports) {
module.exports = import("k9rMK").then(()=>parcelRequire('gl2v3'));

});

parcelRegister("8vE1O", function(module, exports) {
module.exports = import("5OhFn").then(()=>parcelRequire('gyIrk'));

});

parcelRegister("8zAUd", function(module, exports) {
module.exports = import("bRX4y").then(()=>parcelRequire('cJnkM'));

});

parcelRegister("gyxoc", function(module, exports) {
module.exports = import("eBKHC").then(()=>parcelRequire('1mE4K'));

});

parcelRegister("kRhAd", function(module, exports) {
module.exports = import("jZXl3").then(()=>parcelRequire('4whM3'));

});

parcelRegister("7u9n8", function(module, exports) {
module.exports = import("1guQx").then(()=>parcelRequire('24dlK'));

});

parcelRegister("7CiPK", function(module, exports) {
module.exports = import("40Ogq").then(()=>parcelRequire('i0yNS'));

});

parcelRegister("8BLqv", function(module, exports) {
module.exports = import("eP9kT").then(()=>parcelRequire('i3UXt'));

});

parcelRegister("3ccGn", function(module, exports) {
module.exports = import("iNAJS").then(()=>parcelRequire('3LsOL'));

});

parcelRegister("dYw3h", function(module, exports) {
module.exports = import("gFoGw").then(()=>parcelRequire('25eg0'));

});

parcelRegister("jPuI6", function(module, exports) {
module.exports = import("h8r5O").then(()=>parcelRequire('dQFZY'));

});

parcelRegister("e7TnA", function(module, exports) {
module.exports = import("2gPOJ").then(()=>parcelRequire('h0pZD'));

});

parcelRegister("iTVKm", function(module, exports) {
module.exports = import("fpWp6").then(()=>parcelRequire('7R8Ur'));

});

parcelRegister("1y8kQ", function(module, exports) {
module.exports = import("j82Qr").then(()=>parcelRequire('2Y2Wd'));

});

parcelRegister("eVGdJ", function(module, exports) {
module.exports = import("8f7KR").then(()=>parcelRequire('e4vmD'));

});

parcelRegister("45a6i", function(module, exports) {
module.exports = import("cRm0J").then(()=>parcelRequire('lOvps'));

});

parcelRegister("hJIAG", function(module, exports) {
module.exports = import("dwQ6O").then(()=>parcelRequire('b33WV'));

});

parcelRegister("fmao9", function(module, exports) {
module.exports = import("4ZLfe").then(()=>parcelRequire('2SMUf'));

});



var $01FIu = parcelRequire("01FIu");

var $9dryX = parcelRequire("9dryX");

var $8PbIb = parcelRequire("8PbIb");

var $6tXh2 = parcelRequire("6tXh2");

var $1weAl = parcelRequire("1weAl");
// Controller UI del costruttore di costi deducibili (/piva-ordinaria).
// Sul modello di js/addizionaliComunali.js: stato privato, un init piu' pochi
// getter, alimenta un campo del form principale (#costi). Le regole vengono
// da data/costi-deducibili.json e il calcolo da js/costiDeducibiliCalc.js:
// qui c'e' solo DOM.
//
// Le righe delle categorie sono generate dal catalogo dentro il modale, con
// regola e note visibili sotto ogni voce (niente tooltip: js/tooltips.js
// registra i listener solo al DOMContentLoaded e non funzionerebbe su markup
// generato). Invariante di serializzazione: il dettaglio (getCostiDettaglio)
// esiste solo finche' #costi coincide col totale dedotto ("collegato"); una
// modifica manuale del campo scollega il dettaglio.
// Motore di calcolo puro del costruttore di costi deducibili (P.IVA regime
// ordinario/semplificato). Nessuna dipendenza dal DOM: viene riusato dal
// controller di pagina (js/costiDeducibiliUI.js via js/pivaOrdinaria.js) e dai
// test (tests/costiDeducibili.test.js).
//
// Il motore non conosce le regole fiscali: le legge dal catalogo
// (data/costi-deducibili.json), passato come parametro. Per ogni voce applica,
// in quest'ordine: tetto sulla base -> percentuale del tipo contribuente ->
// plafond dinamico sui ricavi (condiviso tra le categorie che puntano allo
// stesso plafond, consumato nell'ordine del catalogo). Lavora al centesimo:
// l'arrotondamento a euro intero avviene solo quando la UI scrive il campo
// #costi. Riferimenti normativi e verifica delle regole in
// docs/costi-deducibili-piva-teoria-fiscale.md.
const $54dfdf32ab0f644e$var$round2 = (value)=>Math.round((value + Number.EPSILON) * 100) / 100;
const $54dfdf32ab0f644e$var$importoValido = (value)=>{
    const n = parseFloat(value);
    return Number.isFinite(n) && n > 0 ? n : 0;
};
function $54dfdf32ab0f644e$export$73075ddbc40bd0ec(formaAttivita, cassaId, catalogo) {
    const mappa = catalogo?.tipi_contribuente || {};
    for (const [tipo, casse] of Object.entries(mappa)){
        if (Array.isArray(casse) && casse.includes(cassaId)) return tipo;
    }
    if (formaAttivita === 'ditta_artigiana' || formaAttivita === 'ditta_commerciale') return 'impresa';
    if (formaAttivita === 'libero_senza_cassa' || formaAttivita === 'libero_con_cassa') return 'professionista';
    return null;
}
function $54dfdf32ab0f644e$export$ee21d178b0de1133(plafondDef, ricavi) {
    const base = Math.max(0, parseFloat(ricavi) || 0);
    if (!plafondDef) return 0;
    if (Array.isArray(plafondDef.scaglioni_pct)) {
        let limite = 0;
        let precedente = 0;
        for (const [soglia, pct] of plafondDef.scaglioni_pct){
            const tetto = soglia === null ? base : Math.min(base, soglia);
            if (tetto > precedente) limite += (tetto - precedente) * (pct / 100);
            precedente = Math.max(precedente, tetto);
            if (soglia !== null && base <= soglia) break;
        }
        return $54dfdf32ab0f644e$var$round2(limite);
    }
    return $54dfdf32ab0f644e$var$round2(base * ((plafondDef.aliquota_pct || 0) / 100));
}
const $54dfdf32ab0f644e$var$quotaIvaDetraibile = (iva, tipo)=>{
    if (!iva) return 0;
    const quota = iva.quota_detraibile_pct;
    if (quota && typeof quota === 'object') return quota[tipo] || 0;
    return quota || 0;
};
function $54dfdf32ab0f644e$export$cd43c05687662918(input, catalogo) {
    const tipo = [
        'professionista',
        'impresa',
        'agente'
    ].includes(input?.tipo) ? input.tipo : 'professionista';
    const ricavi = Math.max(0, parseFloat(input?.ricavi) || 0);
    // Somma per categoria: piu' voci sulla stessa categoria si accumulano.
    const importi = new Map();
    for (const voce of Array.isArray(input?.voci) ? input.voci : []){
        const importo = $54dfdf32ab0f644e$var$importoValido(voce?.importo);
        if (!voce?.categoriaId || importo <= 0) continue;
        importi.set(voce.categoriaId, (importi.get(voce.categoriaId) || 0) + importo);
    }
    // Stato dei plafond: limite calcolato sui ricavi, consumo progressivo
    // nell'ordine del catalogo (rappresentanza prima degli omaggi, per il
    // professionista che condivide l'1%).
    const plafonds = {};
    const statoPlafond = (id)=>{
        if (!plafonds[id]) plafonds[id] = {
            limite: $54dfdf32ab0f644e$export$ee21d178b0de1133(catalogo?.plafond?.[id], ricavi),
            usato: 0,
            saturato: false
        };
        return plafonds[id];
    };
    const righe = [];
    let totaleSostenuto = 0;
    let totaleDedotto = 0;
    let totaleIvaStimata = 0;
    for (const cat of Array.isArray(catalogo?.categorie) ? catalogo.categorie : []){
        const importo = $54dfdf32ab0f644e$var$round2(importi.get(cat.id) || 0);
        if (importo <= 0) continue;
        if (Array.isArray(cat.solo) && !cat.solo.includes(tipo)) continue;
        const regola = cat.regole?.[tipo];
        if (!regola) continue;
        const pct = Math.max(0, regola.pct || 0);
        const tettoBase = Number.isFinite(regola.tetto_base) ? regola.tetto_base : null;
        const base = tettoBase !== null ? Math.min(importo, tettoBase) : importo;
        const dedottoPre = $54dfdf32ab0f644e$var$round2(base * (pct / 100));
        let dedotto = dedottoPre;
        let plafondLimite = null;
        let plafondResiduo = null;
        if (regola.plafond) {
            const stato = statoPlafond(regola.plafond);
            const residuo = $54dfdf32ab0f644e$var$round2(Math.max(0, stato.limite - stato.usato));
            dedotto = Math.min(dedottoPre, residuo);
            stato.usato = $54dfdf32ab0f644e$var$round2(stato.usato + dedotto);
            if (stato.usato >= stato.limite) stato.saturato = true;
            plafondLimite = stato.limite;
            plafondResiduo = $54dfdf32ab0f644e$var$round2(Math.max(0, stato.limite - stato.usato));
        }
        let limiteApplicato = null;
        if (pct === 0) limiteApplicato = 'indeducibile';
        else if (dedotto < dedottoPre) limiteApplicato = 'plafond';
        else if (tettoBase !== null && importo > tettoBase) limiteApplicato = 'tetto';
        else if (pct < 100) limiteApplicato = 'percentuale';
        const ivaDetraibileStimata = $54dfdf32ab0f644e$var$round2(importo * ((cat.iva?.aliquota_pct || 0) / 100) * ($54dfdf32ab0f644e$var$quotaIvaDetraibile(cat.iva, tipo) / 100));
        righe.push({
            categoriaId: cat.id,
            sostenuto: importo,
            dedotto: $54dfdf32ab0f644e$var$round2(dedotto),
            ivaDetraibileStimata: ivaDetraibileStimata,
            limiteApplicato: limiteApplicato,
            dettaglio: {
                pct: pct,
                tettoBase: tettoBase,
                plafondId: regola.plafond || null,
                plafondLimite: plafondLimite,
                plafondResiduo: plafondResiduo
            }
        });
        totaleSostenuto = $54dfdf32ab0f644e$var$round2(totaleSostenuto + importo);
        totaleDedotto = $54dfdf32ab0f644e$var$round2(totaleDedotto + dedotto);
        totaleIvaStimata = $54dfdf32ab0f644e$var$round2(totaleIvaStimata + ivaDetraibileStimata);
    }
    return {
        righe: righe,
        totaleSostenuto: totaleSostenuto,
        totaleDedotto: totaleDedotto,
        totaleNonDedotto: $54dfdf32ab0f644e$var$round2(totaleSostenuto - totaleDedotto),
        totaleIvaStimata: totaleIvaStimata,
        plafonds: plafonds
    };
}


var $c7483b68c183f2ee$exports = {};
$c7483b68c183f2ee$exports = JSON.parse('{"metadata":{"anno_riferimento":2026,"data_ultimo_aggiornamento":"2026-08-07","fonte":"artt. 54, 54-ter, 54-quinquies, 54-sexies, 54-septies, 66, 95, 102, 108, 109, 164 TUIR; D.Lgs. 192/2024; L. 207/2024 art. 1 c. 81-83; D.L. 84/2025 conv. L. 108/2025; Circolare AdE 15/E del 22/12/2025; artt. 19 e 19-bis1 DPR 633/1972 (IVA); dettaglio e verifiche in docs/costi-deducibili-piva-teoria-fiscale.md"},"tipi_contribuente":{"professionista":["INPS_GS","CASSA_FORENSE","INARCASSA","ENPAM","ENPACL","CNPADC","CNPR","CIPAG","ENPAP","ENPAV","ENPAB","EPAP","EPPI","ENPAPI"],"impresa":["INPS_ART","INPS_COM"],"agente":["ENASARCO_MONO","ENASARCO_PLURI"]},"plafond":{"vitto_prof":{"base":"ricavi","aliquota_pct":2,"label":"2% dei compensi incassati","norma":"art. 54-septies c. 1 TUIR"},"rappr_prof":{"base":"ricavi","aliquota_pct":1,"label":"1% dei compensi incassati","norma":"art. 54-septies c. 2 TUIR"},"rappr_impresa":{"base":"ricavi","scaglioni_pct":[[10000000,1.5],[50000000,0.6],[null,0.4]],"label":"1,5% dei ricavi (fino a 10 milioni)","norma":"art. 108 c. 2 TUIR"}},"gruppi":[{"id":"veicoli","label":"Auto e trasporti","icona":"ph-car"},{"id":"lavoro_trasferte","label":"Trasferte, formazione e collaboratori","icona":"ph-suitcase"},{"id":"sede","label":"Studio, negozio o casa","icona":"ph-buildings"},{"id":"beni_tecnologia","label":"Beni strumentali e tecnologia","icona":"ph-laptop"},{"id":"servizi","label":"Servizi e consulenze","icona":"ph-briefcase"},{"id":"altro","label":"Rappresentanza e altre spese","icona":"ph-gift"}],"categorie":[{"id":"auto_acquisto","gruppo":"veicoli","label":"Acquisto o leasing auto (quota annua)","hint":"La quota di quest\'anno, non il prezzo pieno","regole":{"professionista":{"pct":20,"tetto_base":4519},"impresa":{"pct":20,"tetto_base":4519},"agente":{"pct":80,"tetto_base":6455.71}},"iva":{"aliquota_pct":22,"quota_detraibile_pct":{"professionista":40,"impresa":40,"agente":100},"nota":"IVA detraibile al 40% per l\'uso promiscuo, al 100% per gli agenti (deroga UE prorogata al 2028)"},"nota":"Il tetto di legge (18.075,99 \u20AC sul costo del veicolo, 25.822,84 \u20AC per gli agenti) equivale, con l\'ammortamento in 4 anni, a una quota annua massima di 4.519 \u20AC (6.455,71 \u20AC agenti). Per i professionisti conta un solo veicolo.","norma":"art. 164 c. 1 lett. b TUIR; DM 31/12/1988 (coefficiente 25%)"},{"id":"auto_noleggio","gruppo":"veicoli","label":"Noleggio auto (canoni annui)","regole":{"professionista":{"pct":20,"tetto_base":3615.2},"impresa":{"pct":20,"tetto_base":3615.2},"agente":{"pct":80,"tetto_base":5164.57}},"iva":{"aliquota_pct":22,"quota_detraibile_pct":{"professionista":40,"impresa":40,"agente":100}},"nota":"Il tetto vale per il solo canone di noleggio, ragguagliato ad anno; i servizi del full service ne restano fuori se indicati a parte in fattura.","norma":"art. 164 c. 1 lett. b TUIR"},{"id":"auto_impiego","gruppo":"veicoli","label":"Carburante e spese auto (assicurazione, bollo, manutenzione, pedaggi)","regole":{"professionista":{"pct":20},"impresa":{"pct":20},"agente":{"pct":80}},"iva":{"aliquota_pct":22,"quota_detraibile_pct":{"professionista":40,"impresa":40,"agente":100}},"avvertenza":"Il carburante \xe8 deducibile solo se pagato con carta o altri mezzi tracciabili e documentato da fattura elettronica.","norma":"art. 164 c. 1 TUIR","nota":"Le spese di impiego seguono la percentuale del veicolo, senza tetto."},{"id":"vitto_alloggio","gruppo":"lavoro_trasferte","label":"Ristoranti e hotel (vitto e alloggio)","regole":{"professionista":{"pct":75,"plafond":"vitto_prof"},"impresa":{"pct":75},"agente":{"pct":75}},"iva":{"aliquota_pct":10,"quota_detraibile_pct":100,"nota":"IVA detraibile solo se chiedi la fattura: senza fattura l\'IVA non \xe8 detraibile"},"avvertenza":"Dal 2025, se sostenute in Italia, deducibili solo se pagate con mezzi tracciabili. Non inserire le spese riaddebitate al committente: sono neutre.","norma":"art. 54-septies c. 1; art. 109 c. 5 TUIR"},{"id":"formazione","gruppo":"lavoro_trasferte","label":"Formazione e aggiornamento (corsi, master, convegni)","regole":{"professionista":{"pct":100,"tetto_base":10000},"impresa":{"pct":100},"agente":{"pct":100}},"iva":{"aliquota_pct":22,"quota_detraibile_pct":100},"nota":"Per i professionisti include anche viaggio e soggiorno legati alla formazione (pagati con mezzi tracciabili). Per le imprese qui va il solo corso: vitto e alloggio in trasferta restano al 75% e vanno nella riga dedicata.","norma":"art. 54-septies c. 3; art. 109 c. 5 TUIR"},{"id":"lavoro_dipendenti","gruppo":"lavoro_trasferte","label":"Dipendenti e collaboratori (retribuzioni e contributi)","regole":{"professionista":{"pct":100},"impresa":{"pct":100},"agente":{"pct":100}},"norma":"art. 95 TUIR; art. 54-septies c. 5"},{"id":"affitto_sede","gruppo":"sede","label":"Affitto di studio, ufficio o negozio (uso esclusivo)","regole":{"professionista":{"pct":100},"impresa":{"pct":100},"agente":{"pct":100}},"norma":"artt. 54 / 109 TUIR (inerenza)"},{"id":"utenze_sede","gruppo":"sede","label":"Utenze della sede esclusiva (luce, gas, acqua, internet)","regole":{"professionista":{"pct":100},"impresa":{"pct":100},"agente":{"pct":100}},"iva":{"aliquota_pct":22,"quota_detraibile_pct":100},"norma":"artt. 54 / 109 TUIR (inerenza)"},{"id":"casa_uso_promiscuo","gruppo":"sede","label":"Casa usata anche come studio (canone o rendita + utenze)","hint":"Canone annuo o rendita catastale, pi\xf9 le utenze: il 50% lo calcoliamo noi","regole":{"professionista":{"pct":50},"impresa":{"pct":50},"agente":{"pct":50}},"avvertenza":"Professionisti: vale se nello stesso comune non hai un altro immobile a uso esclusivo. Imprese: vale se non hai alcun altro immobile a uso esclusivo dell\'attivit\xe0. L\'IVA su queste spese non \xe8 detraibile.","norma":"art. 54-quinquies c. 3; art. 64 c. 2 TUIR"},{"id":"telefonia","gruppo":"beni_tecnologia","label":"Telefono e connettivit\xe0 (fisso, mobile, traffico)","regole":{"professionista":{"pct":80},"impresa":{"pct":80},"agente":{"pct":80}},"iva":{"aliquota_pct":22,"quota_detraibile_pct":50,"nota":"IVA detraibile secondo l\'uso effettivo: il 50% \xe8 la prassi prudente per l\'uso promiscuo"},"norma":"art. 54-quinquies c. 4; art. 102 c. 9 TUIR"},{"id":"beni_sotto_516","gruppo":"beni_tecnologia","label":"Attrezzatura e beni fino a 516 \u20AC l\'uno","regole":{"professionista":{"pct":100},"impresa":{"pct":100},"agente":{"pct":100}},"iva":{"aliquota_pct":22,"quota_detraibile_pct":100},"nota":"Sotto questa soglia il costo si deduce tutto nell\'anno, senza ammortamento.","norma":"art. 54-quinquies c. 1; art. 102 c. 5 TUIR"},{"id":"ammortamenti_quota","gruppo":"beni_tecnologia","label":"Quote di ammortamento dei beni oltre 516 \u20AC (quota annua)","hint":"Es. computer da 2.000 \u20AC: quota annua 400 \u20AC (coefficiente 20%)","regole":{"professionista":{"pct":100},"impresa":{"pct":100},"agente":{"pct":100}},"nota":"Coefficienti tipici: computer e macchine elettroniche 20%, mobili e arredi 12%. L\'IVA si detrae per intero all\'acquisto.","norma":"art. 54-quinquies c. 1; art. 102 TUIR; DM 31/12/1988"},{"id":"beni_promiscui","gruppo":"beni_tecnologia","label":"Beni usati anche privatamente (PC, tablet, arredi promiscui)","regole":{"professionista":{"pct":50},"impresa":{"pct":50},"agente":{"pct":50}},"nota":"Beni a uso promiscuo lavoro/privato, esclusi i veicoli (hanno le loro righe). L\'IVA si detrae solo per la quota d\'uso professionale documentabile: prudenzialmente non la stimiamo.","norma":"art. 54-quinquies c. 3; art. 64 c. 2 TUIR"},{"id":"software","gruppo":"beni_tecnologia","label":"Software e abbonamenti digitali","regole":{"professionista":{"pct":100},"impresa":{"pct":100},"agente":{"pct":100}},"iva":{"aliquota_pct":22,"quota_detraibile_pct":100},"nota":"Le licenze pluriennali si deducono in quote sulla durata del contratto.","norma":"art. 54-sexies c. 2; art. 103 TUIR"},{"id":"consulenze","gruppo":"servizi","label":"Consulenze (commercialista, legali, notaio)","regole":{"professionista":{"pct":100},"impresa":{"pct":100},"agente":{"pct":100}},"iva":{"aliquota_pct":22,"quota_detraibile_pct":100},"norma":"artt. 54 / 109 TUIR (inerenza)"},{"id":"pubblicita","gruppo":"servizi","label":"Pubblicit\xe0 e marketing (sito, campagne, inserzioni)","regole":{"professionista":{"pct":100},"impresa":{"pct":100},"agente":{"pct":100}},"iva":{"aliquota_pct":22,"quota_detraibile_pct":100},"norma":"art. 108 c. 1 TUIR; artt. 54 / 109 (inerenza)"},{"id":"assicurazioni","gruppo":"servizi","label":"Assicurazioni professionali (RC, tutela legale, crediti)","regole":{"professionista":{"pct":100},"impresa":{"pct":100},"agente":{"pct":100}},"nota":"I premi assicurativi sono esenti IVA.","norma":"artt. 54 / 109 TUIR; art. 54-septies c. 4"},{"id":"spese_bancarie_interessi","gruppo":"servizi","label":"Spese bancarie e interessi passivi inerenti","regole":{"professionista":{"pct":100},"impresa":{"pct":100},"agente":{"pct":100}},"nota":"Gli interessi su ritardati versamenti di imposte non sono deducibili.","norma":"art. 54 c. 1; art. 61 TUIR"},{"id":"rappresentanza","gruppo":"altro","label":"Spese di rappresentanza (cene e ospitalit\xe0 offerte a clienti)","regole":{"professionista":{"pct":75,"plafond":"rappr_prof"},"impresa":{"pct":75,"plafond":"rappr_impresa"},"agente":{"pct":75,"plafond":"rappr_impresa"}},"nota":"Doppio limite: le cene e l\'ospitalit\xe0 si riducono prima al 75% (come vitto e alloggio), poi l\'importo ridotto entra nel plafond. Le spese di rappresentanza non alimentari sarebbero al 100% entro lo stesso plafond: inserirle qui produce una stima prudente.","avvertenza":"Dal 2025 deducibili solo se pagate con mezzi tracciabili. L\'IVA su queste spese non \xe8 detraibile.","norma":"art. 54-septies c. 2; art. 108 c. 2 TUIR; Circ. AdE 53/E/2008 e 34/E/2009"},{"id":"omaggi_50","gruppo":"altro","label":"Omaggi a clienti fino a 50 \u20AC l\'uno","regole":{"professionista":{"pct":100,"plafond":"rappr_prof"},"impresa":{"pct":100},"agente":{"pct":100}},"iva":{"aliquota_pct":22,"quota_detraibile_pct":100},"nota":"Per le imprese gli omaggi entro 50 \u20AC sono interamente deducibili, fuori dal plafond di rappresentanza.","norma":"art. 108 c. 2 TUIR; art. 19-bis1 lett. h DPR 633/1972"},{"id":"merci","gruppo":"altro","label":"Merci e materie prime","solo":["impresa","agente"],"regole":{"impresa":{"pct":100},"agente":{"pct":100}},"iva":{"aliquota_pct":22,"quota_detraibile_pct":100},"nota":"In contabilit\xe0 semplificata si deducono quando le paghi; le rimanenze non contano.","norma":"art. 66 TUIR"},{"id":"cancelleria_materiali","gruppo":"altro","label":"Cancelleria, materiali di consumo, libri professionali","regole":{"professionista":{"pct":100},"impresa":{"pct":100},"agente":{"pct":100}},"iva":{"aliquota_pct":22,"quota_detraibile_pct":100},"norma":"artt. 54 / 109 TUIR (inerenza)"},{"id":"compensi_familiari","gruppo":"altro","label":"Compensi a coniuge, figli minorenni o inabili, genitori","regole":{"professionista":{"pct":0},"impresa":{"pct":0},"agente":{"pct":0}},"nota":"Non sono deducibili (in cambio non sono tassati per chi li riceve). Sono invece deducibili i compensi ai figli maggiorenni abili al lavoro e le prestazioni fatturate dal familiare con la propria partita IVA: quelle vanno tra le altre categorie.","norma":"art. 54-septies c. 6; art. 60 TUIR; C.M. 137/E/1997"}]}');


// Eventi GA4 (via GTM dataLayer) del costruttore di costi deducibili.
// Convenzione del sito: push su window.dataLayer con { event, ...props },
// GTM inoltra a GA4. Nessun dato finanziario negli eventi: solo contatori
// e flag, mai gli importi inseriti dall'utente.
const $fb1c969dc3deaecc$var$push = (event, params = {})=>{
    if (typeof window === 'undefined') return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: event,
        ...params
    });
};
// "Aperto" conta una volta per pagina: interessa quanti scoprono il tool,
// non i rimbalzi apri/chiudi.
let $fb1c969dc3deaecc$var$openInviato = false;
function $fb1c969dc3deaecc$export$3d20e6e9cb7c4e50() {
    if ($fb1c969dc3deaecc$var$openInviato) return;
    $fb1c969dc3deaecc$var$openInviato = true;
    $fb1c969dc3deaecc$var$push('costi_builder_open');
}
function $fb1c969dc3deaecc$export$435aa87632e550ba({ categorie: categorie, conTetto: conTetto, conPlafond: conPlafond }) {
    $fb1c969dc3deaecc$var$push('costi_builder_apply', {
        categorie_compilate: categorie,
        limiti_tetto: conTetto,
        limiti_plafond: conPlafond
    });
}
// L'utente ha riscritto a mano il campo costi dopo aver usato il costruttore:
// il dettaglio si scollega. Conta una volta per pagina.
let $fb1c969dc3deaecc$var$detachInviato = false;
function $fb1c969dc3deaecc$export$4dd129d14c549f7c() {
    if ($fb1c969dc3deaecc$var$detachInviato) return;
    $fb1c969dc3deaecc$var$detachInviato = true;
    $fb1c969dc3deaecc$var$push('costi_builder_detach');
}
// Il blocco "sostenuti vs dedotti" e' stato mostrato nella pagina risultati.
let $fb1c969dc3deaecc$var$confrontoInviato = false;
function $fb1c969dc3deaecc$export$3687ceeed02f5be8() {
    if ($fb1c969dc3deaecc$var$confrontoInviato) return;
    $fb1c969dc3deaecc$var$confrontoInviato = true;
    $fb1c969dc3deaecc$var$push('costi_confronto_visto');
}


const $b260bfa33f91e46b$var$euro = (value)=>`${Math.round(value).toLocaleString('it-IT')} \u{20AC}`;
// Articoli corretti davanti ai numeri: "all'80%", "al 20%", "l'1%", "il 2%".
const $b260bfa33f91e46b$var$alPct = (pct)=>/^(1$|8|11)/.test(String(pct)) ? `all'${pct}%` : `al ${pct}%`;
const $b260bfa33f91e46b$var$conArticolo = (label)=>/^1(?!\d)/.test(label) ? `l'${label}` : `il ${label}`;
let $b260bfa33f91e46b$var$opzioni = null; // { costiElement, getContesto, onApply }
let $b260bfa33f91e46b$var$importi = new Map(); // categoriaId -> importo sostenuto (anche righe nascoste)
let $b260bfa33f91e46b$var$collegato = false; // #costi coincide col totale dedotto corrente
let $b260bfa33f91e46b$var$usato = false; // il costruttore e' stato applicato almeno una volta
let $b260bfa33f91e46b$var$ultimoEsito = null;
const $b260bfa33f91e46b$var$el = (id)=>document.getElementById(id);
// --- Descrizione della regola sotto ogni voce ------------------------------
const $b260bfa33f91e46b$var$descriviRegola = (cat, tipo)=>{
    const regola = cat.regole[tipo];
    if (!regola) return '';
    const parti = [];
    if (regola.pct === 0) parti.push('Non deducibile');
    else {
        let base = `Deducibile ${$b260bfa33f91e46b$var$alPct(regola.pct)}`;
        if (Number.isFinite(regola.tetto_base)) base += ` su massimo ${$b260bfa33f91e46b$var$euro(regola.tetto_base)}`;
        if (regola.plafond) {
            const plafond = (0, (/*@__PURE__*/$parcel$interopDefault($c7483b68c183f2ee$exports))).plafond[regola.plafond];
            if (plafond?.label) base += `, entro ${$b260bfa33f91e46b$var$conArticolo(plafond.label)}`;
        }
        parti.push(base);
    }
    const quotaIva = cat.iva ? typeof cat.iva.quota_detraibile_pct === 'object' ? cat.iva.quota_detraibile_pct[tipo] : cat.iva.quota_detraibile_pct : null;
    if (Number.isFinite(quotaIva) && quotaIva > 0) parti.push(`IVA detraibile ${quotaIva}%`);
    if (cat.norma) parti.push(cat.norma);
    return parti.join(" \xb7 ");
};
// --- Costruzione del corpo del modale --------------------------------------
const $b260bfa33f91e46b$var$costruisciCorpo = ()=>{
    const corpo = $b260bfa33f91e46b$var$el('costiBuilderBody');
    if (!corpo) return;
    const frammento = document.createDocumentFragment();
    for (const gruppo of (0, (/*@__PURE__*/$parcel$interopDefault($c7483b68c183f2ee$exports))).gruppi){
        const categorie = (0, (/*@__PURE__*/$parcel$interopDefault($c7483b68c183f2ee$exports))).categorie.filter((c)=>c.gruppo === gruppo.id);
        if (categorie.length === 0) continue;
        const intestazione = document.createElement('h3');
        intestazione.className = 'costi-builder__gruppo';
        intestazione.innerHTML = `<i class="ph ${gruppo.icona}" aria-hidden="true"></i> ${gruppo.label}`;
        frammento.appendChild(intestazione);
        for (const cat of categorie){
            const rigaEl = document.createElement('div');
            rigaEl.className = 'costi-builder__row';
            rigaEl.dataset.categoria = cat.id;
            rigaEl.innerHTML = `
                <div class="costi-builder__info">
                    <label for="cb-${cat.id}">${cat.label}</label>
                    <p class="costi-builder__regola" data-regola></p>
                    ${cat.hint ? `<p class="costi-builder__hint">${cat.hint}</p>` : ''}
                    ${cat.nota ? `<p class="costi-builder__nota">${cat.nota}</p>` : ''}
                    ${cat.avvertenza ? `<p class="costi-builder__avvertenza"><i class="ph ph-warning" aria-hidden="true"></i> ${cat.avvertenza}</p>` : ''}
                </div>
                <div class="costi-builder__importo">
                    <input type="number" id="cb-${cat.id}" min="0" step="50" inputmode="decimal"
                           placeholder="\u{20AC} annui" aria-label="Importo annuo: ${cat.label}">
                    <span class="costi-builder__dedotto" data-dedotto hidden></span>
                    <span class="costi-builder__badge" data-badge hidden></span>
                </div>`;
            frammento.appendChild(rigaEl);
        }
    }
    corpo.appendChild(frammento);
    corpo.addEventListener('input', (event)=>{
        const input = event.target.closest('input[type="number"]');
        if (!input) return;
        const id = input.id.replace(/^cb-/, '');
        const valore = Math.max(0, parseFloat(input.value) || 0);
        if (valore > 0) $b260bfa33f91e46b$var$importi.set(id, valore);
        else $b260bfa33f91e46b$var$importi.delete(id);
        $b260bfa33f91e46b$var$ricalcola();
    });
};
// --- Ricalcolo e rendering -------------------------------------------------
const $b260bfa33f91e46b$var$contesto = ()=>{
    const { ricavi: ricavi, formaAttivita: formaAttivita, cassaId: cassaId } = $b260bfa33f91e46b$var$opzioni.getContesto();
    return {
        ricavi: ricavi,
        tipo: (0, $54dfdf32ab0f644e$export$73075ddbc40bd0ec)(formaAttivita, cassaId, (0, (/*@__PURE__*/$parcel$interopDefault($c7483b68c183f2ee$exports)))) || 'professionista'
    };
};
const $b260bfa33f91e46b$var$vociVisibili = (tipo)=>{
    const voci = [];
    for (const cat of (0, (/*@__PURE__*/$parcel$interopDefault($c7483b68c183f2ee$exports))).categorie){
        if (Array.isArray(cat.solo) && !cat.solo.includes(tipo)) continue;
        const importo = $b260bfa33f91e46b$var$importi.get(cat.id) || 0;
        if (importo > 0) voci.push({
            categoriaId: cat.id,
            importo: importo
        });
    }
    return voci;
};
const $b260bfa33f91e46b$var$ricalcola = ()=>{
    if (!$b260bfa33f91e46b$var$opzioni) return null;
    const { ricavi: ricavi, tipo: tipo } = $b260bfa33f91e46b$var$contesto();
    const esito = (0, $54dfdf32ab0f644e$export$cd43c05687662918)({
        voci: $b260bfa33f91e46b$var$vociVisibili(tipo),
        ricavi: ricavi,
        tipo: tipo
    }, (0, (/*@__PURE__*/$parcel$interopDefault($c7483b68c183f2ee$exports))));
    $b260bfa33f91e46b$var$ultimoEsito = esito;
    for (const cat of (0, (/*@__PURE__*/$parcel$interopDefault($c7483b68c183f2ee$exports))).categorie){
        const rigaEl = document.querySelector(`.costi-builder__row[data-categoria="${cat.id}"]`);
        if (!rigaEl) continue;
        const nascosta = Array.isArray(cat.solo) && !cat.solo.includes(tipo);
        rigaEl.hidden = nascosta;
        if (nascosta) continue;
        rigaEl.querySelector('[data-regola]').textContent = $b260bfa33f91e46b$var$descriviRegola(cat, tipo);
        const rigaEsito = esito.righe.find((r)=>r.categoriaId === cat.id);
        const dedottoEl = rigaEl.querySelector('[data-dedotto]');
        const badgeEl = rigaEl.querySelector('[data-badge]');
        if (!rigaEsito) {
            dedottoEl.hidden = true;
            badgeEl.hidden = true;
            continue;
        }
        dedottoEl.hidden = false;
        dedottoEl.textContent = `\u{2192} deduci ${$b260bfa33f91e46b$var$euro(rigaEsito.dedotto)}`;
        let badge = '';
        if (rigaEsito.limiteApplicato === 'indeducibile') badge = 'non deducibile';
        else if (rigaEsito.limiteApplicato === 'plafond') badge = ricavi > 0 ? `oltre ${$b260bfa33f91e46b$var$conArticolo((0, (/*@__PURE__*/$parcel$interopDefault($c7483b68c183f2ee$exports))).plafond[rigaEsito.dettaglio.plafondId]?.label || 'limite')}` : 'il limite dipende dai ricavi: compila prima il campo Ricavi';
        else if (rigaEsito.limiteApplicato === 'tetto') badge = `tetto ${$b260bfa33f91e46b$var$euro(rigaEsito.dettaglio.tettoBase)}`;
        badgeEl.hidden = !badge;
        badgeEl.textContent = badge;
    }
    $b260bfa33f91e46b$var$el('costiBuilderTotSostenuto').textContent = $b260bfa33f91e46b$var$euro(esito.totaleSostenuto);
    $b260bfa33f91e46b$var$el('costiBuilderTotDedotto').textContent = $b260bfa33f91e46b$var$euro(esito.totaleDedotto);
    $b260bfa33f91e46b$var$el('costiBuilderTotIva').textContent = `~${$b260bfa33f91e46b$var$euro(esito.totaleIvaStimata)}`;
    const applica = $b260bfa33f91e46b$var$el('costiBuilderApply');
    if (applica) applica.disabled = esito.righe.length === 0;
    return esito;
};
// --- Recap sotto il campo costi --------------------------------------------
const $b260bfa33f91e46b$var$aggiornaRecap = ()=>{
    const recap = $b260bfa33f91e46b$var$el('costiBuilderRecap');
    if (!recap) return;
    if (!$b260bfa33f91e46b$var$usato) {
        recap.hidden = true;
        return;
    }
    recap.hidden = false;
    if ($b260bfa33f91e46b$var$collegato && $b260bfa33f91e46b$var$ultimoEsito) {
        const n = $b260bfa33f91e46b$var$ultimoEsito.righe.length;
        recap.className = 'costi-builder__recap';
        recap.innerHTML = `<strong>${$b260bfa33f91e46b$var$euro($b260bfa33f91e46b$var$ultimoEsito.totaleDedotto)}</strong> dedotti su ` + `${$b260bfa33f91e46b$var$euro($b260bfa33f91e46b$var$ultimoEsito.totaleSostenuto)} sostenuti \xb7 ${n} ${n === 1 ? 'categoria' : 'categorie'} ` + `<button type="button" class="costi-builder__link" data-costi-open>Modifica</button>`;
    } else {
        recap.className = 'costi-builder__recap costi-builder__recap--staccato';
        recap.innerHTML = 'Totale modificato a mano: il dettaglio per categoria non \xe8 pi\xf9 allineato. <button type="button" class="costi-builder__link" data-costi-open>Riapri il costruttore</button>';
    }
};
// --- Apertura / chiusura ----------------------------------------------------
const $b260bfa33f91e46b$var$apri = ()=>{
    const modal = $b260bfa33f91e46b$var$el('costiBuilderModal');
    if (!modal) return;
    $b260bfa33f91e46b$var$ricalcola();
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('modal-open');
    (0, $fb1c969dc3deaecc$export$3d20e6e9cb7c4e50)();
    const primoInput = modal.querySelector('.costi-builder__row:not([hidden]) input');
    window.setTimeout(()=>primoInput?.focus(), 50);
};
const $b260bfa33f91e46b$var$chiudi = ()=>{
    const modal = $b260bfa33f91e46b$var$el('costiBuilderModal');
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('modal-open');
};
const $b260bfa33f91e46b$var$applica = ()=>{
    const esito = $b260bfa33f91e46b$var$ricalcola();
    if (!esito) return;
    const totale = Math.round(esito.totaleDedotto);
    $b260bfa33f91e46b$var$opzioni.costiElement.value = totale;
    $b260bfa33f91e46b$var$collegato = true;
    $b260bfa33f91e46b$var$usato = true;
    $b260bfa33f91e46b$var$aggiornaRecap();
    $b260bfa33f91e46b$var$chiudi();
    (0, $fb1c969dc3deaecc$export$435aa87632e550ba)({
        categorie: esito.righe.length,
        conTetto: esito.righe.filter((r)=>r.limiteApplicato === 'tetto').length,
        conPlafond: esito.righe.filter((r)=>r.limiteApplicato === 'plafond').length
    });
    // change (non input): il listener di scollegamento ascolta solo input,
    // cosi' la scrittura programmatica non si auto-scollega.
    $b260bfa33f91e46b$var$opzioni.costiElement.dispatchEvent(new Event('change', {
        bubbles: true
    }));
    $b260bfa33f91e46b$var$opzioni.onApply?.(totale);
};
function $b260bfa33f91e46b$export$b697bf40b5901849(opts) {
    $b260bfa33f91e46b$var$opzioni = opts;
    $b260bfa33f91e46b$var$costruisciCorpo();
    document.querySelectorAll('[data-costi-open]').forEach((btn)=>btn.addEventListener('click', $b260bfa33f91e46b$var$apri));
    // Il recap rigenera il bottone "Modifica": delega sul contenitore.
    $b260bfa33f91e46b$var$el('costiBuilderRecap')?.addEventListener('click', (event)=>{
        if (event.target.closest('[data-costi-open]')) $b260bfa33f91e46b$var$apri();
    });
    const modal = $b260bfa33f91e46b$var$el('costiBuilderModal');
    modal?.addEventListener('click', (event)=>{
        if (event.target.matches('[data-costi-close]')) $b260bfa33f91e46b$var$chiudi();
    });
    modal?.addEventListener('keydown', (event)=>{
        if (event.key === 'Escape') $b260bfa33f91e46b$var$chiudi();
    });
    $b260bfa33f91e46b$var$el('costiBuilderApply')?.addEventListener('click', $b260bfa33f91e46b$var$applica);
    // Modifica manuale di #costi: il dettaglio non e' piu' il totale, scollega.
    opts.costiElement?.addEventListener('input', ()=>{
        if (!$b260bfa33f91e46b$var$usato || !$b260bfa33f91e46b$var$collegato) return;
        $b260bfa33f91e46b$var$collegato = false;
        $b260bfa33f91e46b$var$aggiornaRecap();
        (0, $fb1c969dc3deaecc$export$4dd129d14c549f7c)();
    });
}
function $b260bfa33f91e46b$export$4526930de6f4d79b() {
    if (!$b260bfa33f91e46b$var$opzioni) return;
    const esito = $b260bfa33f91e46b$var$ricalcola();
    if ($b260bfa33f91e46b$var$collegato && esito) {
        const totale = Math.round(esito.totaleDedotto);
        if (parseFloat($b260bfa33f91e46b$var$opzioni.costiElement.value) !== totale) {
            $b260bfa33f91e46b$var$opzioni.costiElement.value = totale;
            $b260bfa33f91e46b$var$opzioni.costiElement.dispatchEvent(new Event('change', {
                bubbles: true
            }));
        }
        $b260bfa33f91e46b$var$aggiornaRecap();
    }
}
function $b260bfa33f91e46b$export$5d84a317c0ee4662() {
    if (!$b260bfa33f91e46b$var$collegato || !$b260bfa33f91e46b$var$ultimoEsito || $b260bfa33f91e46b$var$ultimoEsito.righe.length === 0) return null;
    return $b260bfa33f91e46b$var$ultimoEsito.righe.map((r)=>[
            r.categoriaId,
            Math.round(r.sostenuto)
        ]);
}
function $b260bfa33f91e46b$export$5f6831e58831cdb5(cd, costiTotale) {
    if (!$b260bfa33f91e46b$var$opzioni || !Array.isArray(cd) || cd.length === 0) return false;
    const validi = new Set((0, (/*@__PURE__*/$parcel$interopDefault($c7483b68c183f2ee$exports))).categorie.map((c)=>c.id));
    $b260bfa33f91e46b$var$importi = new Map();
    for (const coppia of cd){
        if (!Array.isArray(coppia)) continue;
        const [id, importo] = coppia;
        if (!validi.has(id)) {
            console.warn(`Costruttore costi: categoria sconosciuta nel link, ignorata: ${id}`);
            continue;
        }
        const valore = Math.max(0, parseFloat(importo) || 0);
        if (valore > 0) $b260bfa33f91e46b$var$importi.set(id, valore);
    }
    for (const [id, valore] of $b260bfa33f91e46b$var$importi){
        const input = $b260bfa33f91e46b$var$el(`cb-${id}`);
        if (input) input.value = valore;
    }
    const esito = $b260bfa33f91e46b$var$ricalcola();
    $b260bfa33f91e46b$var$usato = $b260bfa33f91e46b$var$importi.size > 0;
    $b260bfa33f91e46b$var$collegato = Boolean(esito) && Math.round(esito.totaleDedotto) === Math.round(costiTotale || 0);
    $b260bfa33f91e46b$var$aggiornaRecap();
    return $b260bfa33f91e46b$var$collegato;
}





var $avAP4 = parcelRequire("avAP4");

var $cNJzb = parcelRequire("cNJzb");

const $fea87e8922dc815f$var$isResultsPage = window.location.pathname === '/piva-ordinaria/risultati';
const $fea87e8922dc815f$var$SHARE_CAMPAIGN = 'sharing_link';
const $fea87e8922dc815f$var$BASE_PATH = '/piva-ordinaria';
const $fea87e8922dc815f$var$RESULTS_PATH = '/piva-ordinaria/risultati';
const $fea87e8922dc815f$var$encodeParams = (obj)=>{
    try {
        return btoa(encodeURIComponent(JSON.stringify(obj)));
    } catch (e) {
        console.error('encodeParams failed', e);
        return null;
    }
};
const $fea87e8922dc815f$var$decodeParams = (encoded)=>{
    try {
        return JSON.parse(decodeURIComponent(atob(encoded)));
    } catch (e) {
        console.error('decodeParams failed', e);
        return null;
    }
};
const $fea87e8922dc815f$var$formatEuro = (value)=>new Intl.NumberFormat('it-IT', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
        useGrouping: 'always'
    }).format(value);
const $fea87e8922dc815f$var$formatPct = (value)=>`${value.toLocaleString('it-IT', {
        minimumFractionDigits: 1,
        maximumFractionDigits: 1
    })}%`;
const $fea87e8922dc815f$var$gestioni = (0, (/*@__PURE__*/$parcel$interopDefault($avAP4))).gestioni_previdenziali || [];
const $fea87e8922dc815f$var$findGestione = (id)=>$fea87e8922dc815f$var$gestioni.find((g)=>(g.id || g.value) === id) || null;
const $fea87e8922dc815f$var$cassaByForma = {
    libero_senza_cassa: [
        'INPS_GS'
    ],
    libero_con_cassa: [
        'CASSA_FORENSE',
        'INARCASSA',
        'ENPAM',
        'ENPACL',
        'CNPADC',
        'CNPR',
        'CIPAG',
        'ENPAP',
        'ENPAV',
        'ENPAB',
        'EPAP',
        'EPPI',
        'ENPAPI'
    ],
    ditta_artigiana: [
        'INPS_ART'
    ],
    ditta_commerciale: [
        'INPS_COM',
        'ENASARCO_MONO',
        'ENASARCO_PLURI'
    ]
};
const $fea87e8922dc815f$var$isArtCom = (cassaId)=>[
        'INPS_ART',
        'INPS_COM'
    ].includes(cassaId);
// L'agente plurimandatario ha massimale e minimale ENASARCO per ogni mandante.
const $fea87e8922dc815f$var$hasMandantiMultipli = (cassaId)=>Boolean($fea87e8922dc815f$var$findGestione(cassaId)?.mandanti_multipli);
// La detrazione art. 13 c. 5 TUIR riguarda le imprese: solo per loro ha senso
// chiedere se tengono la contabilita' ordinaria per opzione.
const $fea87e8922dc815f$var$isImpresa = (forma)=>[
        'ditta_artigiana',
        'ditta_commerciale'
    ].includes(forma);
// Ricalcola il dettaglio del costruttore di costi da un payload (?d=) con la
// chiave compatta cd = [[categoriaId, importo], ...]. Il chiamante verifica
// l'invariante di serializzazione (totale dedotto === params.costi) prima di
// fidarsi del dettaglio: se non regge, fa fede il totale.
const $fea87e8922dc815f$var$ricalcolaDettaglioCosti = (params)=>{
    if (!Array.isArray(params?.cd) || params.cd.length === 0) return null;
    const tipo = (0, $54dfdf32ab0f644e$export$73075ddbc40bd0ec)(params.formaAttivita, params.cassa, (0, (/*@__PURE__*/$parcel$interopDefault($c7483b68c183f2ee$exports))));
    const voci = params.cd.filter((coppia)=>Array.isArray(coppia)).map(([categoriaId, importo])=>({
            categoriaId: categoriaId,
            importo: importo
        }));
    return (0, $54dfdf32ab0f644e$export$cd43c05687662918)({
        voci: voci,
        ricavi: params.ricavi,
        tipo: tipo
    }, (0, (/*@__PURE__*/$parcel$interopDefault($c7483b68c183f2ee$exports))));
};
document.addEventListener('DOMContentLoaded', ()=>{
    // --- Riferimenti comuni -------------------------------------------------
    const inputSection = document.querySelector('.input-section');
    const resultSection = document.querySelector('.result-section');
    const shareButton = document.getElementById('shareButton');
    const backButton = document.getElementById('backButton');
    const backButtonTop = document.getElementById('pivaBackButtonTop');
    const detailScrollButton = document.getElementById('detailScrollButton');
    const faqScrollButton = document.getElementById('faqScrollButton');
    const accontiScrollButton = document.getElementById('accontiScrollButton');
    // --- Form elements ------------------------------------------------------
    const ricaviElement = document.getElementById('ricavi');
    const ricaviFormattedElement = document.getElementById('ricavi-formatted');
    const costiElement = document.getElementById('costi');
    const formaAttivitaElement = document.getElementById('forma-attivita');
    const cassaElement = document.getElementById('cassa-previdenziale');
    const regioneElement = document.getElementById('regione');
    const dipendenteFullTimeElement = document.getElementById('dipendente-fulltime');
    const riduzioneDipendenteElement = document.getElementById('riduzione-contributi-dipendente');
    const dipendenteRiduzioniGroup = document.getElementById('dipendenteRiduzioniGroup');
    const ralDipendenteGroup = document.getElementById('ralDipendenteGroup');
    const ralDipendenteElement = document.getElementById('ral-dipendente');
    const inpsArtComFields = document.getElementById('inpsArtComFields');
    const mesiAttivitaElement = document.getElementById('mesi-attivita');
    const mesiAttivitaGroup = document.getElementById('mesiAttivitaGroup');
    const nuovaAttivitaArtComElement = document.getElementById('nuova-attivita-artcom');
    const riduzione50Element = document.getElementById('riduzione-50');
    const nuovaAttivitaArtcomGroup = document.getElementById('nuovaAttivitaArtcomGroup');
    const riduzione50Group = document.getElementById('riduzione50Group');
    const ante1996Element = document.getElementById('ante-1996');
    const ante1996Group = document.getElementById('ante1996Group');
    const numeroMandantiElement = document.getElementById('numero-mandanti');
    const numeroMandantiGroup = document.getElementById('numeroMandantiGroup');
    const fasciaEtaEnpamElement = document.getElementById('fascia-eta-enpam');
    const fasciaEtaEnpamGroup = document.getElementById('fasciaEtaEnpamGroup');
    const contabilitaOrdinariaElement = document.getElementById('contabilita-ordinaria');
    const contabilitaOrdinariaGroup = document.getElementById('contabilitaOrdinariaGroup');
    const toggleButton = document.getElementById('toggleButton');
    const requiredFields = [
        'ricavi',
        'costi',
        'forma-attivita',
        'cassa-previdenziale',
        'regione',
        'mesi-attivita'
    ];
    // --- Validazione --------------------------------------------------------
    const validateField = (field)=>{
        if (!field) return false;
        if (field.id === 'ricavi') return parseFloat(field.value) > 0;
        if (field.id === 'costi') return Number.isFinite(parseFloat(field.value)) && parseFloat(field.value) >= 0;
        if (field.id === 'mesi-attivita') {
            if (!$fea87e8922dc815f$var$isArtCom(cassaElement?.value)) return true;
            // Con l'esonero il campo e' nascosto: non puo' bloccare il calcolo.
            if (riduzioneDipendenteElement?.checked) return true;
            const m = parseInt(field.value, 10);
            return Number.isInteger(m) && m >= 1 && m <= 12;
        }
        return field.value.trim() !== '';
    };
    const updateFieldHighlighting = ()=>{
        requiredFields.forEach((id)=>document.getElementById(id)?.classList.remove('invalid-field'));
        const firstEmpty = requiredFields.find((id)=>{
            const el = document.getElementById(id);
            return el && !validateField(el);
        });
        if (firstEmpty) document.getElementById(firstEmpty)?.classList.add('invalid-field');
    };
    const updateArtComVisibility = ()=>{
        const artcom = $fea87e8922dc815f$var$isArtCom(cassaElement?.value);
        inpsArtComFields?.classList.toggle('hidden-block', !artcom);
        // Riduzione 50%, nuova iscrizione e mesi di attivita' hanno senso solo
        // senza l'esonero: se non versi nulla alla gestione non c'e' niente da
        // ridurre, ne' un minimale da rapportare ai mesi. Stessa scelta del
        // calcolatore forfettario (js/forfettario.js).
        const hasRiduzioneDip = Boolean(riduzioneDipendenteElement?.checked);
        if (mesiAttivitaElement) {
            mesiAttivitaElement.required = artcom && !hasRiduzioneDip;
            if (artcom && !mesiAttivitaElement.value) mesiAttivitaElement.value = '12';
        }
        mesiAttivitaGroup?.classList.toggle('hidden-block', hasRiduzioneDip);
        nuovaAttivitaArtcomGroup?.classList.toggle('hidden-block', hasRiduzioneDip);
        riduzione50Group?.classList.toggle('hidden-block', hasRiduzioneDip);
        if (hasRiduzioneDip) {
            if (nuovaAttivitaArtComElement) nuovaAttivitaArtComElement.checked = false;
            if (riduzione50Element) riduzione50Element.checked = false;
        }
        // Il massimale ridotto per anzianita' ante-1996 esiste solo per art/com.
        ante1996Group?.classList.toggle('hidden-block', !artcom);
        if (!artcom && ante1996Element) ante1996Element.checked = false;
    };
    const updateMandantiVisibility = ()=>{
        const show = $fea87e8922dc815f$var$hasMandantiMultipli(cassaElement?.value);
        numeroMandantiGroup?.classList.toggle('hidden-block', !show);
        if (!show && numeroMandantiElement) numeroMandantiElement.value = '1';
    };
    // L'ENPAM non ha un minimo unico: la Quota A dipende dalla fascia d'eta'.
    const updateFasciaEtaVisibility = ()=>{
        const show = cassaElement?.value === 'ENPAM';
        fasciaEtaEnpamGroup?.classList.toggle('hidden-block', !show);
    };
    const updateContabilitaVisibility = ()=>{
        const show = $fea87e8922dc815f$var$isImpresa(formaAttivitaElement?.value);
        contabilitaOrdinariaGroup?.classList.toggle('hidden-block', !show);
        if (!show && contabilitaOrdinariaElement) contabilitaOrdinariaElement.checked = false;
    };
    const updateDipendenteVisibility = ()=>{
        const isDip = Boolean(dipendenteFullTimeElement?.checked);
        dipendenteRiduzioniGroup?.classList.toggle('hidden-block', !isDip);
        ralDipendenteGroup?.classList.toggle('hidden-block', !isDip);
        if (!isDip && riduzioneDipendenteElement) riduzioneDipendenteElement.checked = false;
        if (!isDip && ralDipendenteElement) ralDipendenteElement.value = '';
    };
    const updateCassaOptions = ()=>{
        if (!cassaElement) return;
        const forma = formaAttivitaElement?.value || '';
        cassaElement.disabled = !forma;
        if (!forma) {
            cassaElement.value = '';
            return;
        }
        const allowed = forma === 'altro' ? null : $fea87e8922dc815f$var$cassaByForma[forma] || null;
        Array.from(cassaElement.options || []).forEach((opt)=>{
            if (!opt.value) return;
            const ok = !allowed || allowed.includes(opt.value);
            opt.hidden = !ok;
            opt.disabled = !ok;
        });
        if (allowed && allowed.length === 1) cassaElement.value = allowed[0];
        else if (allowed && !allowed.includes(cassaElement.value)) cassaElement.value = '';
    };
    const updateToggleState = ()=>{
        const baseOk = [
            'ricavi',
            'costi',
            'forma-attivita',
            'cassa-previdenziale',
            'regione'
        ].every((id)=>validateField(document.getElementById(id)));
        const mesiOk = !$fea87e8922dc815f$var$isArtCom(cassaElement?.value) || validateField(mesiAttivitaElement);
        if (toggleButton) toggleButton.disabled = !(baseOk && mesiOk);
        updateFieldHighlighting();
    };
    // --- Ricavi: mirror formattato ------------------------------------------
    const setupRicaviMirror = ()=>{
        if (!ricaviElement || !ricaviFormattedElement) return;
        ricaviElement.addEventListener('blur', ()=>{
            let v = parseFloat(ricaviElement.value) || 0;
            if (v < 0) {
                v = 0;
                ricaviElement.value = 0;
            }
            if (v > 0) {
                ricaviFormattedElement.value = v.toLocaleString('it-IT') + "\u20AC";
                ricaviElement.style.display = 'none';
                ricaviFormattedElement.style.display = 'block';
            }
        });
        ricaviFormattedElement.addEventListener('focus', ()=>{
            ricaviFormattedElement.style.display = 'none';
            ricaviElement.style.display = 'block';
            ricaviElement.focus();
        });
    };
    // --- Raccolta / applicazione parametri ----------------------------------
    const collectParams = ()=>{
        const comune = (0, $9dryX.getComuneSelezionato)();
        const fallbackAliquota = parseFloat(document.getElementById('addizionale-comunale')?.value);
        const comunePayload = comune ? {
            nome: comune.nome,
            esenzione: comune.esenzione,
            scaglioni: comune.scaglioni,
            aliquota: comune.aliquota
        } : {
            aliquota: Number.isFinite(fallbackAliquota) ? fallbackAliquota : 0.8
        };
        const params = {
            ricavi: parseFloat(ricaviElement?.value) || 0,
            costi: parseFloat(costiElement?.value) || 0,
            formaAttivita: formaAttivitaElement?.value || '',
            cassa: cassaElement?.value || '',
            regione: regioneElement?.value || '',
            comune: comunePayload,
            dipendenteFullTime: Boolean(dipendenteFullTimeElement?.checked),
            riduzioneDipendente: Boolean(riduzioneDipendenteElement?.checked),
            ralDipendente: parseFloat(ralDipendenteElement?.value) || 0,
            mesiAttivita: parseInt(mesiAttivitaElement?.value, 10) || 12,
            nuovaAttivitaArtCom: Boolean(nuovaAttivitaArtComElement?.checked),
            riduzione50: Boolean(riduzione50Element?.checked),
            ante1996: Boolean(ante1996Element?.checked),
            numeroMandanti: parseInt(numeroMandantiElement?.value, 10) || 1,
            fasciaEtaEnpam: fasciaEtaEnpamElement?.value || 'over40',
            contabilitaOrdinaria: Boolean(contabilitaOrdinariaElement?.checked)
        };
        // Dettaglio del costruttore di costi, solo se ancora allineato a #costi.
        const cd = (0, $b260bfa33f91e46b$export$5d84a317c0ee4662)();
        if (cd) params.cd = cd;
        return params;
    };
    const getParamsFromUrl = ()=>{
        const search = new URLSearchParams(window.location.search);
        if (search.has('d')) {
            const decoded = $fea87e8922dc815f$var$decodeParams(search.get('d'));
            if (decoded && typeof decoded === 'object') return decoded;
        }
        return null;
    };
    const applyParamsToForm = (params)=>{
        if (!params) return;
        if (ricaviElement) ricaviElement.value = params.ricavi || '';
        if (costiElement) costiElement.value = params.costi ?? 0;
        if (formaAttivitaElement) formaAttivitaElement.value = params.formaAttivita || '';
        updateCassaOptions();
        if (cassaElement) cassaElement.value = params.cassa || '';
        if (regioneElement) regioneElement.value = params.regione || '';
        if (dipendenteFullTimeElement) dipendenteFullTimeElement.checked = Boolean(params.dipendenteFullTime);
        if (riduzioneDipendenteElement) riduzioneDipendenteElement.checked = Boolean(params.riduzioneDipendente);
        if (ralDipendenteElement) ralDipendenteElement.value = params.ralDipendente || '';
        if (mesiAttivitaElement) mesiAttivitaElement.value = params.mesiAttivita || 12;
        if (nuovaAttivitaArtComElement) nuovaAttivitaArtComElement.checked = Boolean(params.nuovaAttivitaArtCom);
        if (riduzione50Element) riduzione50Element.checked = Boolean(params.riduzione50);
        if (ante1996Element) ante1996Element.checked = Boolean(params.ante1996);
        if (numeroMandantiElement) numeroMandantiElement.value = params.numeroMandanti || 1;
        if (fasciaEtaEnpamElement) fasciaEtaEnpamElement.value = params.fasciaEtaEnpam || 'over40';
        if (contabilitaOrdinariaElement) contabilitaOrdinariaElement.checked = Boolean(params.contabilitaOrdinaria);
        // Ripristino comune: il campo va valorizzato PRIMA di initComuneAutocomplete,
        // cosi' il modulo (che al load riconosce la regione gia' selezionata) ricompone
        // la selezione ufficiale. L'aliquota flat resta come fallback.
        const comuneInput = document.getElementById('comune');
        const aliquotaInput = document.getElementById('addizionale-comunale');
        if (params.comune) {
            if (comuneInput && params.comune.nome) comuneInput.value = params.comune.nome;
            if (aliquotaInput && Number.isFinite(params.comune.aliquota)) aliquotaInput.value = params.comune.aliquota;
        }
    };
    const redirectToResults = ()=>{
        const encoded = $fea87e8922dc815f$var$encodeParams(collectParams());
        const qs = encoded ? `d=${encodeURIComponent(encoded)}` : '';
        window.history.replaceState({}, '', qs ? `${$fea87e8922dc815f$var$BASE_PATH}?${qs}` : $fea87e8922dc815f$var$BASE_PATH);
        window.location.href = qs ? `${$fea87e8922dc815f$var$RESULTS_PATH}?${qs}` : $fea87e8922dc815f$var$RESULTS_PATH;
    };
    const redirectToHomeWithQuery = ()=>{
        const qs = window.location.search;
        window.location.href = qs ? `${$fea87e8922dc815f$var$BASE_PATH}${qs}` : $fea87e8922dc815f$var$BASE_PATH;
    };
    // --- Rendering risultati ------------------------------------------------
    const buildCalcInput = (params)=>({
            ricavi: params.ricavi,
            costiDeducibili: params.costi,
            gestione: $fea87e8922dc815f$var$findGestione(params.cassa),
            regione: params.regione,
            comune: params.comune || {},
            dipendenteFullTime: params.dipendenteFullTime,
            riduzioneDipendente: params.riduzioneDipendente,
            ralDipendente: params.ralDipendente,
            mesiAttivita: params.mesiAttivita,
            nuovaAttivitaArtCom: params.nuovaAttivitaArtCom,
            riduzione50: params.riduzione50,
            ante1996: params.ante1996,
            numeroMandanti: params.numeroMandanti,
            fasciaEtaEnpam: params.fasciaEtaEnpam,
            contabilitaOrdinaria: params.contabilitaOrdinaria,
            year: '2026'
        });
    const setText = (id, value)=>{
        const el = document.getElementById(id);
        if (el) el.textContent = value;
    };
    const setVal = (id, value)=>{
        const el = document.getElementById(id);
        if (el) el.value = value;
    };
    const setHtml = (id, value)=>{
        const el = document.getElementById(id);
        if (el) el.innerHTML = value;
    };
    const renderAcconti = (r, gestioneId)=>{
        const a = r.acconti;
        const I = r.irpefNetta;
        const addizTot = r.addizionaleRegionale + r.addizionaleComunale;
        // Per le scadenze conta quanto esce di tasca: l'integrativo in rivalsa
        // lo incassi dal cliente prima di girarlo alla cassa.
        const C = r.contributiACarico;
        const Cfissi = r.contributiFissi;
        const euro = (v)=>`${$fea87e8922dc815f$var$formatEuro(v)} \u{20AC}`;
        const accIrpefTot = a.irpef.accontoTotale;
        const accInpsTot = a.inps.accontoTotale;
        const hasAcconto = accIrpefTot + accInpsTot > 0;
        const annuale = I + addizTot + C; // imposte + contributi di un anno
        const saldoPrimoAnno = annuale; // saldo del 1° anno, versato il 2°
        // Seconde rate di novembre (acconti, uguali ogni anno).
        const novRate = a.irpef.acconto2 + a.inps.rata2;
        // 2° anno: saldo del 1° anno + tutti gli acconti (raddoppio).
        const tot2 = saldoPrimoAnno + accIrpefTot + accInpsTot + a.comunale;
        const giu2 = tot2 - novRate;
        // A regime: stesse due scadenze, ma il totale è una sola annualità.
        const giuR = annuale - novRate;
        const row = (date, label, value)=>`<div class="piva-scadenza-row"><span class="piva-scadenza-date">${date}</span>` + `<span class="piva-scadenza-label">${label}</span>` + `<span class="piva-scadenza-value">${euro(value)}</span></div>`;
        const totale = (label, value, tag)=>`<div class="piva-anno-totale"><span>${label}</span>` + `<span>${euro(value)}${tag ? ` <em>${tag}</em>` : ''}</span></div>`;
        const note = (txt)=>`<p class="piva-anno-note">${txt}</p>`;
        // 1° anno: dipende dalla presenza di contributi minimi in rate fisse.
        if (Cfissi > 0) setHtml('annoUno', note("Nel primo anno versi solo i contributi minimi INPS, in 4 rate fisse. Saldo e acconto (IRPEF e contributi sull'eccedenza) scattano dal secondo anno.") + totale('Contributi minimi nell\'anno', Cfissi));
        else setHtml('annoUno', note("Nel primo anno saldo e acconto non sono dovuti: non c'\xe8 un'imposta dell'anno precedente su cui calcolarli. Eventuali contributi minimi di cassa restano dovuti secondo le regole della tua cassa.") + totale('Totale versato nell\'anno', 0));
        // 2° anno e a regime.
        if (!hasAcconto) {
            setHtml('annoDue', row('30 giu', "Saldo del 1\xb0 anno (imposte + contributi)", saldoPrimoAnno) + note('Nessun acconto dovuto: si versa solo il saldo, senza raddoppio.') + totale('Totale nell\'anno', saldoPrimoAnno));
            setHtml('annoRegime', row('30 giu', 'Saldo dell\'anno (imposte + contributi)', annuale) + totale('Totale nell\'anno', annuale));
        } else {
            const ratio = annuale > 0 ? tot2 / annuale : 0;
            const tag2 = ratio >= 1.7 ? "\u2248 doppio" : "pi\xf9 pesante";
            setHtml('annoDue', row('30 giu', "Saldo del 1\xb0 anno + primi acconti", giu2) + row('30 nov', 'Secondi acconti', novRate) + totale('Totale nell\'anno', tot2, tag2));
            setHtml('annoRegime', row('30 giu', 'Saldo residuo + primi acconti', giuR) + row('30 nov', 'Secondi acconti', novRate) + totale('Totale nell\'anno', annuale));
        }
        // Legenda: di cosa è fatto l'acconto (dipende dalla gestione).
        const li = (txt)=>`<li>${txt}</li>`;
        const items = [
            li('<strong>IRPEF</strong>: acconto 100% (40% al 30/6 + 60% al 30/11).')
        ];
        if (gestioneId === 'INPS_GS') items.push(li('<strong>INPS Gestione Separata</strong>: acconto 80%, in due rate del 40% (30/6 e 30/11).'));
        else if (gestioneId === 'INPS_ART' || gestioneId === 'INPS_COM') items.push(li("<strong>INPS Artigiani/Commercianti</strong>: il minimale si versa in 4 rate fisse (senza acconto); acconto 80% solo sull'eccedenza."));
        else if (gestioneId) items.push(li('<strong>Cassa professionale / ENASARCO</strong>: acconti e scadenze secondo il regolamento della tua gestione (non stimati qui).'));
        items.push(li('<strong>Addizionale comunale</strong>: acconto 30%; <strong>regionale</strong>: nessun acconto (solo saldo).'));
        items.push(li("<strong>IVA</strong>: ha un acconto a s\xe9 (entro il 27 dicembre), ma \xe8 neutra \u2014 la incassi dai clienti e la versi allo Stato, non incide sul netto."));
        setHtml('accontoLegenda', `<ul class="piva-legenda-list">${items.join('')}</ul>`);
        // Consiglio: accantonamento annuo (imposte + contributi).
        setText('tipAccantona', euro(annuale));
    };
    // --- Confronto con il forfettario ---------------------------------------
    // L'ordinario non chiede il codice ATECO ne' l'anzianita' di attivita', che
    // servono per il forfettario: si parte da un default coerente con la forma
    // di attivita' scelta e si lascia all'utente la possibilita' di correggerlo.
    const confrontoCoefficiente = document.getElementById('confronto-coefficiente');
    const confrontoStartup = document.getElementById('confronto-startup');
    let confrontoInizializzato = false;
    // I listener dei controlli leggono sempre gli ultimi parametri, non quelli
    // catturati alla prima esecuzione: dopo una modifica rapida i valori cambiano.
    let confrontoParams = null;
    const renderConfrontoForfettario = (params)=>{
        if (!document.getElementById('confrontoRegimi')) return;
        confrontoParams = params;
        if (!confrontoInizializzato) {
            if (confrontoCoefficiente) confrontoCoefficiente.value = String((0, $6tXh2.coefficienteDefault)(params.formaAttivita));
            const ricalcola = ()=>renderConfrontoForfettario(confrontoParams);
            confrontoCoefficiente?.addEventListener('change', ricalcola);
            confrontoStartup?.addEventListener('change', ricalcola);
            confrontoInizializzato = true;
        }
        const coefficiente = parseFloat(confrontoCoefficiente?.value) || 78;
        const aliquotaImposta = confrontoStartup?.checked ? 5 : 15;
        const calcInput = buildCalcInput(params);
        const esito = (0, $6tXh2.confrontaRegimi)({
            ...calcInput,
            coefficienteRedditivita: coefficiente,
            aliquotaImposta: aliquotaImposta,
            // La riduzione 35% esiste solo nel forfettario: la si ipotizza
            // richiesta se l'utente ha gia' dichiarato di essere un nuovo
            // iscritto Artigiani/Commercianti.
            riduzione35: Boolean(params.nuovaAttivitaArtCom) && $fea87e8922dc815f$var$isArtCom(params.cassa)
        }, (0, (/*@__PURE__*/$parcel$interopDefault($cNJzb))));
        (0, $1weAl.renderConfronto)(esito, {
            origine: 'ordinario',
            ctaHref: (0, $1weAl.linkAlForfettario)({
                // Oltre la soglia il confronto e' calcolato sul fatturato
                // massimo ammesso: il calcolatore forfettario va aperto con
                // lo stesso numero, non con ricavi che il regime non consente.
                ricavi: esito.fatturatoForfettario,
                coefficienteRedditivita: coefficiente,
                aliquotaImposta: aliquotaImposta,
                formaAttivita: params.formaAttivita,
                cassa: params.cassa,
                mesiAttivita: params.mesiAttivita,
                nuovaAttivitaArtCom: params.nuovaAttivitaArtCom,
                riduzione50: params.riduzione50,
                riduzione35: Boolean(params.nuovaAttivitaArtCom) && $fea87e8922dc815f$var$isArtCom(params.cassa),
                dipendenteFullTime: params.dipendenteFullTime,
                ralDipendente: params.ralDipendente,
                riduzioneDipendente: params.riduzioneDipendente
            }),
            notaIpotesi: `Il coefficiente di redditivit\xe0 dipende dal tuo codice ATECO: qui \xe8 impostato al ${coefficiente}%, correggilo se il tuo \xe8 diverso. ` + 'Nel forfettario non si applica l\'IVA in fattura e non si detrae quella sugli acquisti.'
        });
    };
    // Blocco "sostenuti vs dedotti": compare solo se il payload porta il
    // dettaglio del costruttore (cd) e l'invariante col totale regge ancora.
    // Payload vecchi o totale inserito a mano: pagina identica a prima.
    const renderCostiConfronto = (params)=>{
        const blocco = document.getElementById('costiConfronto');
        if (!blocco) return;
        const esito = $fea87e8922dc815f$var$ricalcolaDettaglioCosti(params);
        if (!esito || esito.righe.length === 0 || Math.round(esito.totaleDedotto) !== Math.round(params.costi || 0)) {
            blocco.style.display = 'none';
            return;
        }
        setText('costiSostenutiTot', `${$fea87e8922dc815f$var$formatEuro(esito.totaleSostenuto)} \u{20AC}`);
        setText('costiDedottiTot', `${$fea87e8922dc815f$var$formatEuro(esito.totaleDedotto)} \u{20AC}`);
        setText('costiNonDedottiTot', `${$fea87e8922dc815f$var$formatEuro(esito.totaleNonDedotto)} \u{20AC}`);
        setText('costiIvaStimata', `~${$fea87e8922dc815f$var$formatEuro(esito.totaleIvaStimata)} \u{20AC}`);
        const corpo = document.getElementById('costiConfrontoRighe');
        if (corpo) corpo.innerHTML = esito.righe.map((riga)=>{
            const categoria = (0, (/*@__PURE__*/$parcel$interopDefault($c7483b68c183f2ee$exports))).categorie.find((c)=>c.id === riga.categoriaId);
            return `<tr><td>${categoria?.label || riga.categoriaId}</td>` + `<td>${$fea87e8922dc815f$var$formatEuro(riga.sostenuto)} \u{20AC}</td>` + `<td>${$fea87e8922dc815f$var$formatEuro(riga.dedotto)} \u{20AC}</td></tr>`;
        }).join('');
        blocco.style.display = '';
        (0, $fb1c969dc3deaecc$export$3687ceeed02f5be8)();
    };
    const renderResults = (params)=>{
        if (!resultSection) return;
        const r = (0, $8PbIb.calcolaPivaOrdinaria)(buildCalcInput(params), (0, (/*@__PURE__*/$parcel$interopDefault($cNJzb))));
        setText('pivaNettoAnnuale', `${$fea87e8922dc815f$var$formatEuro(r.nettoAnnuo)} \u{20AC}`);
        setText('pivaNettoMensile', `${$fea87e8922dc815f$var$formatEuro(r.nettoMensile)} \u{20AC}`);
        setText('pivaHeroMensile', `\u{2248} ${$fea87e8922dc815f$var$formatEuro(r.nettoMensile)} \u{20AC} al mese (media)`);
        setText('pivaRicaviTile', `${$fea87e8922dc815f$var$formatEuro(r.ricavi)} \u{20AC}`);
        setText('pivaBreakNetto', `${$fea87e8922dc815f$var$formatEuro(r.nettoAnnuo)} \u{20AC}`);
        setText('pivaBreakCosti', `${$fea87e8922dc815f$var$formatEuro(r.costi)} \u{20AC}`);
        // Nella ripartizione dei ricavi entra solo la quota di contributi che
        // esce davvero di tasca: l'integrativo in rivalsa e' una partita di giro.
        setText('pivaBreakContributi', `${$fea87e8922dc815f$var$formatEuro(r.contributiACarico)} \u{20AC}`);
        setText('pivaBreakIrpef', `${$fea87e8922dc815f$var$formatEuro(r.irpefNetta)} \u{20AC}`);
        setText('pivaBreakAddizionali', `${$fea87e8922dc815f$var$formatEuro(r.addizionaleRegionale + r.addizionaleComunale)} \u{20AC}`);
        document.querySelectorAll('.js-fido-tasse').forEach((el)=>{
            el.textContent = `${$fea87e8922dc815f$var$formatEuro(r.contributiACarico + r.imposteTotali)} \u{20AC}`;
        });
        // Barra a 5 segmenti (percentuali dei ricavi, clampate a [0,100]).
        const pct = (v)=>r.ricavi > 0 ? Math.min(Math.max(v / r.ricavi * 100, 0), 100) : 0;
        const setSegment = (segId, pctId, value)=>{
            const share = pct(value);
            const seg = document.getElementById(segId);
            if (seg) seg.style.width = `${share}%`;
            setText(pctId, $fea87e8922dc815f$var$formatPct(share));
        };
        setSegment('pivaSegNetto', 'pivaPctNetto', Math.max(r.nettoAnnuo, 0));
        setSegment('pivaSegCosti', 'pivaPctCosti', r.costi);
        setSegment('pivaSegContributi', 'pivaPctContributi', r.contributiACarico);
        setSegment('pivaSegIrpef', 'pivaPctIrpef', r.irpefNetta);
        setSegment('pivaSegAddizionali', 'pivaPctAddizionali', r.addizionaleRegionale + r.addizionaleComunale);
        // Dettaglio
        setVal('ricaviDetail', `${$fea87e8922dc815f$var$formatEuro(r.ricavi)} \u{20AC}`);
        setVal('costiDetail', `${$fea87e8922dc815f$var$formatEuro(r.costi)} \u{20AC}`);
        renderCostiConfronto(params);
        setVal('redditoLordoDetail', `${$fea87e8922dc815f$var$formatEuro(r.redditoLordo)} \u{20AC}`);
        setVal('contributiDetail', `${$fea87e8922dc815f$var$formatEuro(r.contributi)} \u{20AC}`);
        // Casse professionali: l'integrativo si addebita al cliente, quindi il
        // netto sconta solo i contributi effettivamente a carico.
        const integrativoRow = document.getElementById('integrativoDetailRow');
        if (integrativoRow) {
            if (r.integrativoRivalsa > 0) {
                setVal('integrativoDetail', `${$fea87e8922dc815f$var$formatEuro(r.contributoIntegrativo)} \u{20AC}`);
                setVal('contributiACaricoDetail', `${$fea87e8922dc815f$var$formatEuro(r.contributiACarico)} \u{20AC}`);
                integrativoRow.style.display = '';
            } else integrativoRow.style.display = 'none';
        }
        setVal('imponibileIrpefDetail', `${$fea87e8922dc815f$var$formatEuro(r.imponibileIrpef)} \u{20AC}`);
        setVal('irpefLordaDetail', `${$fea87e8922dc815f$var$formatEuro(r.irpefLorda)} \u{20AC}`);
        setVal('detrazioneDetail', `${$fea87e8922dc815f$var$formatEuro(r.detrazioni)} \u{20AC}`);
        setVal('irpefNettaDetail', `${$fea87e8922dc815f$var$formatEuro(r.irpefNetta)} \u{20AC}`);
        // Con reddito da dipendente la riga non è più una detrazione che spetta,
        // ma la variazione (in genere una perdita) delle detrazioni già godute.
        if (r.redditoDipendente > 0 && r.detrazioni < 0) {
            setText('detrazioneDetailLabel', 'Variazione detrazioni');
            setText('detrazioneDetailTipTitle', 'Variazione delle detrazioni');
            setText('detrazioneDetailTipText', "Il reddito P.IVA si somma allo stipendio e fa scendere le detrazioni da lavoro dipendente gi\xe0 godute in busta paga (e l'ulteriore detrazione tra 20.000 e 40.000 \u20AC). La differenza torna a debito in dichiarazione ed \xe8 un costo reale della partita IVA. La detrazione da lavoro autonomo non si somma a quella da dipendente: si sceglie la pi\xf9 favorevole (art. 13 c. 5 TUIR).");
        } else {
            setText('detrazioneDetailLabel', 'Detrazione lavoro autonomo');
            setText('detrazioneDetailTipTitle', 'Detrazione lavoro autonomo');
            setText('detrazioneDetailTipText', "Detrazione IRPEF spettante sui redditi di lavoro autonomo (art. 13 TUIR): riduce l'imposta lorda. Decresce all'aumentare del reddito e si azzera oltre 50.000 \u20AC.");
        }
        setVal('addizionaleRegionaleDetail', `${$fea87e8922dc815f$var$formatEuro(r.addizionaleRegionale)} \u{20AC}`);
        setVal('addizionaleComunaleDetail', `${$fea87e8922dc815f$var$formatEuro(r.addizionaleComunale)} \u{20AC}`);
        setVal('imposteTotaliDetail', `${$fea87e8922dc815f$var$formatEuro(r.imposteTotali)} \u{20AC}`);
        setVal('nettoAnnuoDetail', `${$fea87e8922dc815f$var$formatEuro(r.nettoAnnuo)} \u{20AC}`);
        setVal('nettoMensileDetail', `${$fea87e8922dc815f$var$formatEuro(r.nettoMensile)} \u{20AC}`);
        // Nota: con reddito da dipendente/pensione l'IRPEF della P.IVA è calcolata
        // all'aliquota marginale sul reddito complessivo.
        const marginaleNota = document.getElementById('marginaleNota');
        if (marginaleNota) {
            if (r.redditoDipendente > 0) {
                let testo = `IRPEF e addizionali calcolate all'<strong>aliquota marginale</strong> ` + `sul reddito complessivo (dipendente ${$fea87e8922dc815f$var$formatEuro(r.redditoDipendente)} \u{20AC} + P.IVA ${$fea87e8922dc815f$var$formatEuro(r.imponibileIrpef)} \u{20AC} ` + `= ${$fea87e8922dc815f$var$formatEuro(r.imponibileTotale)} \u{20AC}), perch\xe9 nel regime ordinario i redditi si sommano.`;
                if (r.detrazioni < 0) testo += ` Il conto include <strong>${$fea87e8922dc815f$var$formatEuro(-r.detrazioni)} \u{20AC}</strong> di detrazioni che perdi ` + `sullo stipendio: si ricalcolano sul reddito complessivo e tornano a debito in dichiarazione.`;
                if (r.sommaIntegrativaPersa > 0) testo += ` \u{26A0}\u{FE0F} Superando i 20.000 \u{20AC} di reddito complessivo perdi anche il trattamento integrativo, ` + `circa <strong>${$fea87e8922dc815f$var$formatEuro(r.sommaIntegrativaPersa)} \u{20AC}</strong> l'anno in busta paga: non \xe8 un'imposta, ` + `quindi non \xe8 conteggiato qui sopra, ma \xe8 un costo in pi\xf9 della partita IVA.`;
                marginaleNota.innerHTML = `<i class="ph ph-info"></i><span>${testo}</span>`;
                marginaleNota.style.display = 'flex';
            } else marginaleNota.style.display = 'none';
        }
        // Massimale contributivo: oltre la soglia il reddito non è più assoggettato.
        const massimaleNota = document.getElementById('massimaleNota');
        if (massimaleNota) {
            if (r.massimaleApplicato) {
                massimaleNota.innerHTML = `<i class="ph ph-info"></i><span>Contributi calcolati fino al <strong>massimale annuo di ` + `${$fea87e8922dc815f$var$formatEuro(r.massimaleContributivo)} \u{20AC}</strong>: sulla parte di reddito eccedente ` + `(${$fea87e8922dc815f$var$formatEuro(r.imponibileContributi - r.imponibilePrevidenziale)} \u{20AC}) non si versano contributi.</span>`;
                massimaleNota.style.display = 'flex';
            } else massimaleNota.style.display = 'none';
        }
        // Casse professionali modellate a percentuale pura: avvisa che i minimi
        // della cassa non sono compresi nella stima.
        const minimiCassaNota = document.getElementById('minimiCassaNota');
        if (minimiCassaNota) {
            const gestione = $fea87e8922dc815f$var$findGestione(params.cassa);
            if (gestione?.minimi_non_modellati) {
                minimiCassaNota.innerHTML = `<i class="ph ph-warning"></i><span>Per <strong>${gestione.label}</strong> la stima applica solo ` + `l'aliquota sul reddito: <strong>non include i contributi minimi</strong> (soggettivo e integrativo) ` + `n\xe9 il contributo di maternit\xe0 previsti dalla cassa, che sono dovuti anche a reddito basso. ` + `Verifica gli importi sul sito della tua cassa.</span>`;
                minimiCassaNota.style.display = 'flex';
            } else minimiCassaNota.style.display = 'none';
        }
        renderAcconti(r, params.cassa);
        renderConfrontoForfettario(params);
        if (inputSection) inputSection.style.display = 'none';
        resultSection.style.display = 'block';
        window.scrollTo(0, 0);
    };
    // --- Quick edit (ricavi + costi) ----------------------------------------
    const quickModal = document.getElementById('pivaQuickEditModal');
    const quickClose = document.getElementById('pivaQuickEditClose');
    const quickForm = document.getElementById('pivaQuickEditForm');
    const quickRicavi = document.getElementById('piva-quick-ricavi');
    const quickRicaviFormatted = document.getElementById('piva-quick-ricavi-formatted');
    const quickCosti = document.getElementById('piva-quick-costi');
    const quickToConfig = document.getElementById('pivaQuickEditToConfigurator');
    let quickScrollY = 0;
    const showQuickFormatted = ()=>{
        if (!quickRicavi || !quickRicaviFormatted) return;
        let v = parseFloat(quickRicavi.value) || 0;
        if (v < 0) v = 0;
        quickRicavi.value = Math.round(v);
        if (v > 0) {
            quickRicaviFormatted.value = `${Math.round(v).toLocaleString('it-IT')} \u{20AC}`;
            quickRicavi.style.display = 'none';
            quickRicaviFormatted.style.display = 'block';
        } else {
            quickRicaviFormatted.value = '';
            quickRicavi.style.display = 'block';
            quickRicaviFormatted.style.display = 'none';
        }
    };
    const openQuickModal = ()=>{
        if (!$fea87e8922dc815f$var$isResultsPage || !quickModal) return;
        const params = getParamsFromUrl();
        if (quickRicavi) quickRicavi.value = Math.round(params?.ricavi || 0);
        if (quickCosti) quickCosti.value = Math.round(params?.costi || 0);
        showQuickFormatted();
        quickModal.classList.add('is-open');
        quickModal.setAttribute('aria-hidden', 'false');
        quickScrollY = window.scrollY || 0;
        document.documentElement.classList.add('modal-open');
        document.body.classList.add('modal-open');
        document.body.style.position = 'fixed';
        document.body.style.top = `-${quickScrollY}px`;
        document.body.style.width = '100%';
    };
    const closeQuickModal = ()=>{
        if (!quickModal) return;
        quickModal.classList.remove('is-open');
        quickModal.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('modal-open');
        document.body.classList.remove('modal-open');
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.width = '';
        window.scrollTo(0, quickScrollY);
    };
    // ========================================================================
    // Inizializzazione per pagina
    // ========================================================================
    if (!$fea87e8922dc815f$var$isResultsPage) {
        const params = getParamsFromUrl();
        if (params) applyParamsToForm(params);
        // initComuneAutocomplete DOPO aver valorizzato regione/comune, cosi'
        // ricompone l'eventuale selezione ufficiale al ritorno dai risultati.
        (0, $9dryX.initComuneAutocomplete)();
        // Costruttore di costi deducibili: legge il contesto (ricavi, forma,
        // cassa) sempre fresco dal form e scrive il totale dedotto in #costi.
        (0, $b260bfa33f91e46b$export$b697bf40b5901849)({
            costiElement: costiElement,
            getContesto: ()=>({
                    ricavi: parseFloat(ricaviElement?.value) || 0,
                    formaAttivita: formaAttivitaElement?.value || '',
                    cassaId: cassaElement?.value || ''
                })
        });
        if (params?.cd) (0, $b260bfa33f91e46b$export$5f6831e58831cdb5)(params.cd, params.costi);
        requiredFields.forEach((id)=>{
            const el = document.getElementById(id);
            if (el) {
                el.addEventListener('input', updateToggleState);
                el.addEventListener('change', updateToggleState);
            }
        });
        formaAttivitaElement?.addEventListener('change', ()=>{
            updateCassaOptions();
            updateArtComVisibility();
            updateMandantiVisibility();
            updateFasciaEtaVisibility();
            updateContabilitaVisibility();
            updateToggleState();
            (0, $b260bfa33f91e46b$export$4526930de6f4d79b)();
        });
        cassaElement?.addEventListener('change', ()=>{
            updateArtComVisibility();
            updateMandantiVisibility();
            updateFasciaEtaVisibility();
            updateToggleState();
            (0, $b260bfa33f91e46b$export$4526930de6f4d79b)();
        });
        // I plafond del costruttore (2% vitto, 1%/1,5% rappresentanza) si
        // muovono coi ricavi: ricalcola il dettaglio a ogni modifica.
        ricaviElement?.addEventListener('input', (0, $b260bfa33f91e46b$export$4526930de6f4d79b));
        dipendenteFullTimeElement?.addEventListener('change', ()=>{
            updateDipendenteVisibility();
            updateArtComVisibility();
        });
        riduzioneDipendenteElement?.addEventListener('change', updateArtComVisibility);
        [
            nuovaAttivitaArtComElement,
            riduzione50Element,
            mesiAttivitaElement,
            ante1996Element,
            numeroMandantiElement,
            fasciaEtaEnpamElement,
            contabilitaOrdinariaElement
        ].forEach((el)=>el?.addEventListener('change', updateToggleState));
        setupRicaviMirror();
        if (cassaElement) cassaElement.disabled = !formaAttivitaElement?.value;
        updateCassaOptions();
        updateArtComVisibility();
        updateMandantiVisibility();
        updateFasciaEtaVisibility();
        updateContabilitaVisibility();
        updateDipendenteVisibility();
        updateToggleState();
        toggleButton?.addEventListener('click', ()=>redirectToResults());
    } else {
        const params = getParamsFromUrl();
        if (!params || !params.ricavi || !params.cassa || !params.regione) {
            redirectToHomeWithQuery();
            return;
        }
        renderResults(params);
        backButton?.addEventListener('click', ()=>redirectToHomeWithQuery());
        backButtonTop?.addEventListener('click', ()=>openQuickModal());
        shareButton?.addEventListener('click', ()=>(0, $01FIu.handleShareClick)(shareButton, {
                campaign: $fea87e8922dc815f$var$SHARE_CAMPAIGN
            }));
        const scrollTo = (sel)=>document.querySelector(sel)?.scrollIntoView({
                behavior: 'smooth'
            });
        detailScrollButton?.addEventListener('click', ()=>scrollTo('#dettaglio-calcolo'));
        faqScrollButton?.addEventListener('click', ()=>scrollTo('.faq-container'));
        accontiScrollButton?.addEventListener('click', ()=>scrollTo('#acconti-panel'));
        quickClose?.addEventListener('click', closeQuickModal);
        quickModal?.addEventListener('click', (e)=>{
            if (e.target === quickModal) closeQuickModal();
        });
        quickRicavi?.addEventListener('blur', showQuickFormatted);
        quickRicaviFormatted?.addEventListener('focus', ()=>{
            quickRicaviFormatted.style.display = 'none';
            quickRicavi.style.display = 'block';
            quickRicavi.focus();
        });
        quickToConfig?.addEventListener('click', ()=>{
            const qs = window.location.search;
            window.location.href = qs ? `${$fea87e8922dc815f$var$BASE_PATH}${qs}` : $fea87e8922dc815f$var$BASE_PATH;
        });
        quickForm?.addEventListener('submit', (e)=>{
            e.preventDefault();
            let nextRicavi = parseFloat(quickRicavi?.value) || 0;
            if (nextRicavi < 0) nextRicavi = 0;
            let nextCosti = parseFloat(quickCosti?.value) || 0;
            if (nextCosti < 0) nextCosti = 0;
            if (!nextRicavi) return;
            // Base: l'ultimo payload in URL (un submit precedente puo' gia'
            // aver tolto il dettaglio cd; params in closure sarebbe stantio).
            const updated = {
                ...getParamsFromUrl() || params,
                ricavi: Math.round(nextRicavi),
                costi: Math.round(nextCosti)
            };
            // Invariante cd => costi: il dettaglio del costruttore resta nel
            // payload solo se il totale coincide ancora. Cambiando i costi a
            // mano si stacca; cambiando i ricavi i plafond possono spostarlo.
            if (updated.cd) {
                const esito = $fea87e8922dc815f$var$ricalcolaDettaglioCosti(updated);
                if (!esito || Math.round(esito.totaleDedotto) !== updated.costi) delete updated.cd;
            }
            const encoded = $fea87e8922dc815f$var$encodeParams(updated);
            const qs = encoded ? `d=${encodeURIComponent(encoded)}` : '';
            window.history.replaceState({}, '', qs ? `${$fea87e8922dc815f$var$RESULTS_PATH}?${qs}` : $fea87e8922dc815f$var$RESULTS_PATH);
            renderResults(updated);
            closeQuickModal();
        });
        document.addEventListener('keydown', (e)=>{
            if (e.key === 'Escape' && quickModal?.classList.contains('is-open')) closeQuickModal();
        });
    }
});


//# sourceMappingURL=piva-ordinaria.bc9c02b3.js.map
